import * as React from 'react';
import moment from 'moment';
import injectSheet from 'react-jss';
import {
  Row,
  Col,
  Card,
  Tooltip,
  Icon,
  message,
  Timeline,
  Divider,
  Button,
  Select,
  Tabs,
} from 'antd';
import Loader from 'src/components/common/Loader';
import ExtendDeadlineModal from 'src/components/pages/Enquiry/Modals/ExtendDeadlineModal';
import EditInquiryModal from 'src/components/pages/Enquiry/Modals/EditInquiryModal';
import SendRFQ from 'src/components/pages/Enquiry/Modals/SendRFQ';
import InquiryDeleteModal from 'src/components/pages/Enquiry/Modals/InquiryDeleteModal';
import InquiryDuplicateModal from './Modals/InquiryDuplicateModal';
import withInquiryMasterData from './hoc/InitInquiryMaster';
import { connect } from 'react-redux';
import {
  getInquiryShipperRoute,
  getInquiryEditRoute,
  getDuplicateInquiryRoute,
  getInquiryCreateBidRoute,
} from 'src/routing/utils';
import { withRouter } from 'react-router';
import { getInquiryDetail } from 'src/actions/inquiryShipperActions';
import SendIcon from 'src/components/common/icons/send';
import {
  deleteInquiry,
  fetchInquiryDetailsForShipper,
  fetchInquiryDetailsForFF,
  editAccessInInquiryDetails,
  rejectInquiryFF,
} from 'src/api/inquiry';
import { bindActionCreators } from 'redux';
import { prettifyString } from 'src/utils/utils';
import { nl2Br } from 'src/utils/DOMUtils';
import { fetchAllTeams, fetchUserTeams } from 'src/api/teams';
import TeamForInquiryAccessModal from './Modals/TeamForInquiryAccessModal';
import { getDeadlineData, 
  rejectInquiryShown, 
  visibleAccessTypeLabel, 
  defaultAccessKeys, 
  visibleAccessTypeLabelsForTeamMapped, 
  teamMappedAccessKeys, 
  buildInquiryFieldLabelMap,
  resolveFieldLabel
} from './InquiryUtils';
import { uniqArray, isValidNumber, isValidArray, isValidString } from 'src/Library/Helper';
import classNames from 'classnames';
import { EventCategories, sendEvent } from 'src/utils/gaService';
import isEmpty from 'lodash/isEmpty';
import { SL_RESPONDED_INTTRA_STATUS, BOOKING_STATUS } from './Booking/BookingUtils';
import FFInquiryRejectModal from './Modals/FFInquiryRejectModal';
import FFRevokeInquiryModal from './Modals/FFRevokeInquiryModal';
import InquiryRejectedFFModal from './Modals/InquiryRejectedFFModal';
import BookingDetailModal from './Modals/BookingDetailModal';
import SplitBookingDetails from './Cards/SplitBookingDetails';
import { getConditionalBullets } from 'src/Library/Common';
import { commonStyles } from 'src/Library/CommonStyles';
import TruckingInquiryDetails from './TruckingInquiryDetails';
import { DISPATCH_MODE_LABELS } from './constants';
import { InquiryModes } from 'src/Library/Constants';
import startCase from 'lodash/startCase';
import { getSIPartyAddress } from '../shipment-execution/SE.utils';
import FileViewer from 'src/components/common/FileViewer';
import { tokens } from 'src/design-system';

const styles = (theme) => ({
  body: {
    marginBottom: '30px',
    height: '100%',
  },
  bottomButtons: {
    bottom: 30,
  },
  title: {
    fontSize: `${tokens.fontSize.small}px`,
    overflowWrap: 'break-word',
  },
  value: {
    fontSize: `${tokens.fontSize.body}px`,
    overflowWrap: 'break-word',
  },
  detailsTitle: {
    color: '#262626',
    fontSize: `${tokens.fontSize.body}px`,
    fontWeight: 'bold',
  },
  flexColumn: {
    display: 'flex',
    flexDirection: 'column',
  },
  label: {
    color: '#262626',
    fontSize: `${tokens.fontSize.small}px`,
    wordWrap: 'break-word',
    lineHeight: '12px',
    paddingTop: '2px',
    display: 'inline-block',
  },
  dot: {
    height: '8px',
    width: '8px',
    borderRadius: '5px',
    border: '1px solid #979797',
  },
  dotFilled: {
    backgroundColor: 'rgb(217, 217, 217)',
  },
  labelInfo: {
    color: '#272727',
    fontSize: `${tokens.fontSize.body}px`,
    fontWeight: 'bold',
    wordWrap: 'break-word',
    lineHeight: '14px',
    display: 'inline-block',
  },
  antTimeline: {
    '& .ant-timeline-item-head-custom': {
      padding: '0',
      top: '7px',
    },
    '& .ant-timeline-item-tail': {
      height: 'calc(100% - 6px)',
    },
  },
  bookingSideDrawer: {
    margin: 0,
    border: 'unset',
    '& .ant-card-body': {
      padding: 0,
    },
  },
  bookindDetailsDiv: {
    margin: '0 12px 0 12px',
  },
  bookingType: {
    fontSize: `${tokens.fontSize.h3}px`,
    color: '#000000',
    display: 'flex',
    justifyContent: 'space-between',
  },
  disabledAddBid: {
    background: '#f5f5f5',
    border: '1px solid #D9D9D9',
  },
  addBidBtn: {
    background: COLORS.BLUE,
    border: COLORS.BLUE,
  },
  accessTypeDiv: {
    display: 'flex',
    alignItems: 'center',
    paddingLeft: '16px',
    borderLeft: '1px solid #E9E9E9',
    marginLeft: '16px',
    width: '40%',
    '& .ant-select-selection--single': {
      border: 'unset',
      backgroundColor: '#F7F7F7',
      fontSize: `${tokens.fontSize.small}px`,
    },
    '& .ant-select': {
      minWidth: '60%',
      width: 'auto',
    },
  },
  destinationFreeDays: {
    lineHeight: '16px',
    paddingLeft: '10px',
    marginTop: '-3px',
  },
  rejectedHeaderCard: {
    margin: '0px 12px 8px 12px',
    backgroundColor: '#FFF1F1',
    fontSize: `${tokens.fontSize.body}px`,
    fontWeight: tokens.fontWeight.semibold,
    '& .ant-card-body': {
      padding: '14px',
    },
  },
  rejectedCardText: {
    color: '#262626',
    marginBottom: '12px',
  },
  rejectInquiryText: {
    marginRight: '8px',
    fontSize: `${tokens.fontSize.body}px`,
    width: '128px',
    paddingTop: '18px',
  },
  additionalPortDetails: {
    fontStyle: 'italic',
    fontSize: `${tokens.fontSize.caption}px`,
    fontWeight: 'normal',
  },
  tabContainer: {
    '& .ant-tabs-tab-active': {
      fontSize: `${tokens.fontSize.body}px`,
      fontWeight: 'bold',
      color: COLORS.BLACK,
    },
    '& .ant-tabs-ink-bar': {
      background: COLORS.BLUE,
      height: '4px',
    },
  },
  inttraReferenceDetails: {
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    maxWidth: '100%',
  },
  inttraStatusDetails: {
    color: '#272727',
    fontSize: `${tokens.fontSize.body}px`,
    fontWeight: tokens.fontWeight.semibold,
  },
  responseLabel: {
    fontSize: `${tokens.fontSize.small}px`,
    color: '#262626',
  },
  inttraError: {
    backgroundColor: 'rgba(245,34,45,0.08)',
    padding: '12px',
    fontWeight: tokens.fontWeight.semibold,
    marginBottom: '37px',
    borderRadius: `${tokens.radius.sm}px`,
  },
  splitBookingDetails: {
    backgroundColor: '#FCFCFC',
    padding: '16px',
    borderRadius: `${tokens.radius.md}px`,
    marginBottom: '30px',
  },
  splitBookingHeading: {
    marginBottom: '15px',
    padding: '0 0 10px 0px',
    borderBottom: '1px solid #E9E9E9',
    fontWeight: tokens.fontWeight.semibold,
    color: '#000000',
    fontSize: `${tokens.fontSize.h3}px`,
  },
  statusDot: {
    width: '12px',
    height: '12px',
    borderRadius: '15px',
    marginRight: '6px',
  },
  flexRow: {
    ...commonStyles(theme).flexRow,
  },
  justifySpaceBetween: {
    ...commonStyles(theme).justifySpaceBetween,
  },
  highValue: {
    backgroundColor: '#1990ff',
    padding: '5px',
    borderRadius: '5px',
    color: 'white',
    height: '15px',
    fontSize: '8px',
    display: 'flex',
    alignItems: 'center',
    fontWeight: 'bold'
  }
});

const COLORS = {
  GREEN: '#52C41A',
  RED: '#F5222D',
  BLUE: tokens.colors.primary,
  GREY: '#444444',
  LIGHTGREY: '#D9D9D9',
  BLACK: '#262626',
};

class CreateInquiryDetails extends React.PureComponent<any, any> {
  constructor(props) {
    super(props);
    this.state = {
      newDeadline: null,
      extendDeadlineModalVisible: false,
      editInquiryModalVisible: false,
      sendRFQConfirmationVisible: false,
      createDuplicateVisible: false,
      deleteInquiryVisible: false,
      viewBreakdownVisible: false,
      heading: '',
      isLoading: true,
      deleteModalLoading: false,
      teams: [],
      teamId: undefined,
      teamName: undefined,
      accessType: undefined,
      activeTab: '1',
      inttraErrorReasons: undefined,
      bookingDetailModalVisible: false,
      splitBookingDetails: undefined,
      carrierComments: undefined,
      reasonForSplitting: undefined,
      slBookingNumber: undefined,
      inquiryRejectModalVisible: false,
      isCardLoading: false,
      revokeInquiryModalVisible: false,
      selectedFileViewer: null,
      inquiryFieldLabelMap: {},
    };
  }

  loadInquiryData = async () => {
    const { match } = this.props;
    const inquiryId = match.params.inquiryId;
    const tabId = match.params.tabId;
    tabId === 'details' ? this.setState({ activeKey: '1' }) : this.setState({ activeKey: '2' });
    let response;
    this.setState({
      iconsLoading: true,
    });
    if (this.props.booking) {
      response = {
        isSuccess: true,
        data: this.props.bookingData?.bookingDetails,
        inttraBookingDetails: this.props.bookingData.inttraBookingDetails,
        inttraErrorReasons: this.props.bookingData.inttraErrorReasons,
        splitBookingDetails: this.props.bookingData.splitBookingDetails,
        carrierComments: this.props.bookingData.carrierComments,
        slBookingNumber: this.props.bookingData.slBookingNumber,
        reasonForSplitting: this.props.bookingData.reasonForSplitting,
      };
    } else if (this.props.type === 'SHIPPER') {
      response = await fetchInquiryDetailsForShipper({ inquiryId });
    } else {
      response = await fetchInquiryDetailsForFF({ inquiryId });
    }

    const inquiryCustomFieldLabelMap = this.buildFieldLabelMap(
      response.data?.mode
    );

    if (response.isSuccess) {
      this.setState({
        inquiryData: response.data,
        newDeadline: response.data.deadline,
        teamId: response.data.accessorId,
        accessType: response.data.accessorType,
        teamName: response.data.teamName,
        inttraBookingDetails: response.inttraBookingDetails,
        inttraErrorReasons: response.inttraErrorReasons,
        splitBookingDetails: response.splitBookingDetails,
        carrierComments: response.carrierComments,
        slBookingNumber: response.slBookingNumber,
        reasonForSplitting: response.reasonForSplitting,
        inquiryFieldLabelMap : inquiryCustomFieldLabelMap ,
      });
    }
    this.setState({
      iconsLoading: false,
      isLoading: false,
    });
  };

  async componentDidMount() {

    const {isDefaultInquiryTeamMapping, userRole , inquiryDefaultFormConfig} = this.props
    const showDefaultMappedUserTeam = isDefaultInquiryTeamMapping && userRole !== 'ADMIN'
    this.setState({ isLoading: true });
    await this.loadInquiryData();
    this.fetchTeams(showDefaultMappedUserTeam);
    // this.props.

    const mode = this.state.inquiryData?.mode ? this.state.inquiryData.mode : null;
    const customFieldNamesConfig = inquiryDefaultFormConfig?.[mode];
    this.setState({
      inquiryFormFieldConfig: customFieldNamesConfig,
      inquiryFieldLabelMap: buildInquiryFieldLabelMap(customFieldNamesConfig)
    });

  }

  fetchTeams = async (showDefaultMappedUserTeam: boolean) => {
    let response 
    if (showDefaultMappedUserTeam) {
      response = await fetchUserTeams()
    } else {
      response = await fetchAllTeams({ adminTeamRestriction: true });
    }
    if (response.isSuccess) {
      const filteredTeams = this.props.organisationId ? response.data.filter(team => team.organisation_id === this.props.organisationId) : response.data;
      this.setState({ teams: filteredTeams });
    }
  };

  editInquiryModalHandleOk = async () => {
    const { history, match } = this.props;
    const inquiryId = match.params.inquiryId;
    history.push(getInquiryEditRoute(inquiryId));
    this.setState({ isLoading: true });
    await this.loadInquiryData();
    this.setState({ isLoading: false });
  };

  editInquiryModalHandleCancel = () => {
    this.setState({ editInquiryModalVisible: false });
  };

  extendDeadlineModalHandleOk = async (newDeadline) => {
    const { history } = this.props;
    this.setState({ extendDeadlineModalVisible: false });
    this.props.getInquiryDetail(this.state.inquiryData.id);
    this.setState({ newDeadline });
    this.setState({ isLoading: true });
    await this.loadInquiryData();
    this.setState({ isLoading: false });
    sendEvent(
      EventCategories.INQUIRY_SEND,
      'Edit Inquiry - Deadline Extended',
      'Inquiry Details Page'
    );
  };

  extendDeadlineModalHandleCancel = () => {
    this.setState({ extendDeadlineModalVisible: false });
  };

  sendRFQConfirmationHandleOk = async () => {
    this.setState({ sendRFQConfirmationVisible: false });
    await this.loadInquiryData();
    await this.props.getSidePanelData();
  };

  sendRFQConfirmationHandleCancel = () => {
    this.setState({ sendRFQConfirmationVisible: false });
  };

  createDuplicateHandleOk = () => {
    const { history, match } = this.props;
    const inquiryId = match.params.inquiryId;
    history.push(getDuplicateInquiryRoute(inquiryId));
  };

  createDuplicateHandleCancel = () => {
    this.setState({ createDuplicateVisible: false });
  };

  deleteInquiryHandleOk = async () => {
    const { history, modeList } = this.props;
    this.setState({ deleteModalLoading: true });
    const response = await deleteInquiry({ inquiryId: this.state.inquiryData.id, shipperId: this.state.inquiryData.shipperId });
    if (response.isSuccess) message.success('Inquiry Deleted');
    else message.error('Unable to delete inquiry');
    this.setState({ deleteModalLoading: false });
    history.push(getInquiryShipperRoute(isValidArray(modeList) ? `modeList=${modeList}` : ''));
  };

  deleteInquiryHandleCancel = () => {
    this.setState({ deleteInquiryVisible: false });
  };

  handleAddBid = (inquiryId) => {
    if (this.props.data?.isDeadlinePassed) return;
    sendEvent(EventCategories.INQUIRY_BIDDING, 'Add Bid - Clicked', 'Inquiry Details Page');
    const { history } = this.props;
    history.push(getInquiryCreateBidRoute(inquiryId), 'fromDetails');
  };

  handleRejectInquiry = async (reasons, remarks) => {
    const { id: inquiryId } = this.props.data;
    this.setState({ isCardLoading: true });
    const response = await rejectInquiryFF({ inquiryId, reasons, remarks });
    if (response.isSuccess) {
      this.setState({ inquiryRejectModalVisible: false });
      this.handleLoadInquiry();
    } else {
      message.error(response.errorMessage);
    }
    this.setState({ isCardLoading: false });
  };

  handleCancel = () => this.setState({ inquiryRejectModalVisible: false });

  handleRevokeInquiryCancel = () => this.setState({ revokeInquiryModalVisible: false });

  renderModals = () => {
    const { inquiryData: data, newDeadline } = this.state;
    return (
      <div>
        <EditInquiryModal
          heading="Edit"
          visible={this.state.editInquiryModalVisible}
          handleOk={this.editInquiryModalHandleOk}
          handleCancel={this.editInquiryModalHandleCancel}
        />
        <ExtendDeadlineModal
          sailingDate={data.preferredSailingDate}
          deadline={newDeadline}
          inquiryId={data.id}
          shipperId={data.shipperId}
          visible={this.state.extendDeadlineModalVisible}
          handleOk={this.extendDeadlineModalHandleOk}
          handleCancel={this.extendDeadlineModalHandleCancel}
        />
        <SendRFQ
          referenceNumber={data.referenceNumber}
          deadline={newDeadline}
          sentFfIds={data.sentFfIds}
          inquiryId={data.id}
          inquiryMode={data.mode}
          visible={this.state.sendRFQConfirmationVisible}
          handleOk={this.sendRFQConfirmationHandleOk}
          handleCancel={this.sendRFQConfirmationHandleCancel}
        />
        <InquiryDuplicateModal
          visible={this.state.createDuplicateVisible}
          handleOk={this.createDuplicateHandleOk}
          handleCancel={this.createDuplicateHandleCancel}
        />
        <InquiryDeleteModal
          visible={this.state.deleteInquiryVisible}
          handleOk={this.deleteInquiryHandleOk}
          handleCancel={this.deleteInquiryHandleCancel}
          isLoading={this.state.deleteModalLoading}
        />
      </div>
    );
  };

  renderIcons = () => {
    const { INQUIRY_ALL_ACTIONS, INQUIRY_CREATE_UPDATE_ACTIONS, INQUIRY_SEND_ACTIONS } = this.props.permissions;
    const { classes, userStatus, organisationId } = this.props;
    const { inquiryData: data } = this.state;
    const isOpenEnabled = data.status === 'OPEN' ? true : false;
    const isOriginalShipper = data.shipperId === organisationId ? true : false;
    const isConfirmEnabled = data.status === 'CONFIRMED' ? true : false;
    const isExtendDeadlineDisabled = isConfirmEnabled || !INQUIRY_CREATE_UPDATE_ACTIONS;
    const isEditDisabled =
      userStatus !== 'INTERNAL' &&
      (isConfirmEnabled ||
        data.ffsSentCount !== 0 ||
        !INQUIRY_CREATE_UPDATE_ACTIONS ||
        data.status === 'CLOSED');
    const isDeleteDisabled = !isOpenEnabled || !INQUIRY_CREATE_UPDATE_ACTIONS;
    const isDraft = data?.otherDetails?.isDraft;

    if (this.state.iconsLoading) {
      return <div></div>;
    }
    const styleEdit =
      isEditDisabled || !INQUIRY_CREATE_UPDATE_ACTIONS
        ? {
          color: COLORS.LIGHTGREY,
        }
        : {
          color: COLORS.GREY,
          cursor: 'pointer',
          fontSize: 22,
        };
    const styleExtendDeadline =
      isExtendDeadlineDisabled || !INQUIRY_CREATE_UPDATE_ACTIONS
        ? {
          color: COLORS.LIGHTGREY,
        }
        : {
          color: COLORS.GREY,
          cursor: 'pointer',
          fontSize: 22,
        };
    const styleSendInquiry =
      isOpenEnabled && INQUIRY_SEND_ACTIONS && !isDraft
        ? {
          fill: COLORS.GREEN,
          cursor: 'pointer',
          marginTop: '2px',
        }
        : {
          fill: COLORS.LIGHTGREY,
          marginTop: '2px',
        };
    const styleDeleteInquiry =
      isDeleteDisabled || !INQUIRY_CREATE_UPDATE_ACTIONS
        ? {
          color: COLORS.LIGHTGREY,
        }
        : {
          color: COLORS.GREY,
          cursor: 'pointer',
          fontSize: 22,
        };
    return (
      <div
        style={{
          textAlign: 'right',
          display: 'flex',
          flexDirection: 'row',
          fontSize: '25px',
          marginRight: '10px',
          padding: '24px 12px',
        }}
      >
        <div
          style={{
            marginLeft: '375px',
            display: 'flex',
            flexDirection: 'row',
            justifyContent: 'space-between',
            width: '200px',
          }}
        >
          <Tooltip title={isEditDisabled || !INQUIRY_CREATE_UPDATE_ACTIONS ? !INQUIRY_CREATE_UPDATE_ACTIONS ? 'Permission Required' : '' : 'Edit'}>
            <Icon
              type="edit"
              className={classes.iconsTheme}
              style={styleEdit}
              onClick={() =>
                isEditDisabled || !INQUIRY_CREATE_UPDATE_ACTIONS ? null : this.editInquiryModalHandleOk()
              }
            />
          </Tooltip>
          <Tooltip
            title={!isExtendDeadlineDisabled && INQUIRY_CREATE_UPDATE_ACTIONS ? 'Extend Deadline' : !INQUIRY_CREATE_UPDATE_ACTIONS ? 'Permission Required' : ''}
          >
            <Icon
              type="calendar"
              className={classes.iconsTheme}
              style={styleExtendDeadline}
              onClick={() =>
                isExtendDeadlineDisabled || !INQUIRY_CREATE_UPDATE_ACTIONS
                  ? null
                  : this.setState({ extendDeadlineModalVisible: true })
              }
            />
          </Tooltip>
          <Tooltip title={INQUIRY_CREATE_UPDATE_ACTIONS ? 'Create Duplicate' : 'Permission Required'}>
            <Icon
              type="copy"
              className={classes.iconsTheme}
              style={{
                color: INQUIRY_CREATE_UPDATE_ACTIONS ? COLORS.GREY : COLORS.LIGHTGREY,
                cursor: INQUIRY_CREATE_UPDATE_ACTIONS ? 'pointer' : 'default',
                fontSize: 22,
              }}
              onClick={() =>
                INQUIRY_CREATE_UPDATE_ACTIONS ? this.setState({ createDuplicateVisible: true }) : undefined
              }
            />
          </Tooltip>
          <Tooltip title={isDeleteDisabled || !INQUIRY_CREATE_UPDATE_ACTIONS ? !INQUIRY_CREATE_UPDATE_ACTIONS ? 'Permission Required' : '' : 'Delete'}>
            <Icon
              type="delete"
              className={classes.iconsTheme}
              style={styleDeleteInquiry}
              onClick={
                isDeleteDisabled || !INQUIRY_CREATE_UPDATE_ACTIONS
                  ? undefined
                  : () => this.setState({ deleteInquiryVisible: true })
              }
            />
          </Tooltip>
          {isOriginalShipper && (
          <Tooltip
            title={isOpenEnabled && INQUIRY_SEND_ACTIONS && !isDraft? 'Send Inquiry' : !INQUIRY_SEND_ACTIONS ? 'Permission Required' : ''}
            placement="bottomLeft"
            trigger={this.state.sendRFQConfirmationVisible ? 'click' : 'hover'}
          >
            <SendIcon
              backgroundColor="#000000"
              className={classes.iconsTheme}
              style={styleSendInquiry}
              onClick={() =>
                isOpenEnabled && INQUIRY_SEND_ACTIONS && !isDraft
                  ? this.setState({ sendRFQConfirmationVisible: true })
                  : undefined
              }
            />
          </Tooltip>
          )}
        </div>
        {this.renderModals()}
      </div>
    );
  };

  handleAccessTypeChange = async (val) => {
    const inquiryId = this.props.match.params.inquiryId;
    const shipperId = this.props.data?.shipperId;
    if (val !== 'TEAM') {
      this.setState({ accessType: val, teamId: undefined });
      const response = await editAccessInInquiryDetails({ inquiryId, accessType: val, shipperId });
      if (response.isSuccess) {
        message.success('Inquiry Access Updated Successfully');
      } else {
        message.error(response.errorMessage);
      }
      return;
    }
    this.setState({ isSelectTeamModalVisible: true });
  };

  handleLoadInquiry = async () => {
    this.setState({ isLoading: true });
    await this.loadInquiryData();
    this.setState({ isLoading: false });
  };

  renderRejectInquiry = () => {
    const { classes } = this.props;
    const {
      inquiryData: { referenceNumber, status },
      newDeadline,
    } = this.state;
    return (
      <React.Fragment>
        <a
          style={{
            color: status === 'CLOSED' ? '#AAAAAA' : '#F84307',
            cursor: status === 'CLOSED' ? 'not-allowed' : 'pointer',
          }}
          className={classes.rejectInquiryText}
          onClick={
            status !== 'CLOSED'
              ? () => this.setState({ inquiryRejectModalVisible: true })
              : undefined
          }
        >
          Decline Inquiry
        </a>
        <FFInquiryRejectModal
          loading={this.state.isCardLoading}
          visible={this.state.inquiryRejectModalVisible}
          handleCancel={this.handleCancel}
          deadlineDate={newDeadline}
          inquiryReferenceNumber={referenceNumber}
          handleRejectInquiry={this.handleRejectInquiry}
        />
      </React.Fragment>
    );
  };

  renderRejectedInquiryHeader = () => {
    const { classes, permissions } = this.props;
    const { rejectionReasons, rejectionRemarks, status, id } = this.state.inquiryData;
    const isDisabled = !(status === 'OPEN' && permissions.INQUIRY_BIDDING_ALL_ACTIONS);
    return (
      <Card className={classes.rejectedHeaderCard}>
        <div className={classes.rejectedCardText}>You have declined this inquiry.</div>
        <Row gutter={24} style={{ paddingBottom: '15px', fontSize: `${tokens.fontSize.small}px` }}>
          <Col span={2} style={{ paddingRight: 0 }}>
            Reason
          </Col>
          <Col span={22} style={{ color: '#262626', paddingLeft: 0 }}>
            <ol style={{ margin: '0px 6px', paddingLeft: '2px' }}>
              {rejectionReasons?.map((reason, index) => {
                return <li key={index}>{reason}</li>;
              })}
            </ol>
          </Col>
        </Row>
        {isValidString(rejectionRemarks) && (
          <Row gutter={24} style={{ paddingBottom: '15px', fontSize: `${tokens.fontSize.small}px` }}>
            <Col span={2} style={{ paddingRight: 0 }}>
              Remark
            </Col>
            <Col span={22} style={{ color: '#262626', paddingLeft: 0 }}>
              {nl2Br(rejectionRemarks, '\n')}
            </Col>
          </Row>
        )}
        {this.renderDivider()}
        <div style={{ display: 'flex', float: 'right', color: '#262626' }}>
          <span>Incase your reason has been resolved,</span>
          <span
            style={{
              color: isDisabled ? '#AAAAAA' : tokens.colors.primary,
              cursor: isDisabled ? 'not-allowed' : 'pointer',
            }}
            onClick={
              !isDisabled ? () => this.setState({ revokeInquiryModalVisible: true }) : undefined
            }
          >
            &nbsp;Revoke & Add Bid
          </span>
        </div>
        <FFRevokeInquiryModal
          visible={this.state.revokeInquiryModalVisible}
          handleCancel={this.handleRevokeInquiryCancel}
          handleAddBid={() => this.handleAddBid(id)}
        />
      </Card>
    );
  };

  header = () => {
    const { classes, type, visibleAccessTypes, isDefaultInquiryTeamMapping, userRole, timezone } = this.props;
    const { INQUIRY_CREATE_UPDATE_ACTIONS } = this.props.permissions;
    const { newDeadline, inquiryData: data, accessType, teams } = this.state;
    const { internalReferenceNumber, referenceNumber, bidsSaved, bidsSent, isRejected, otherDetails } = data;
    const showRejectInquiry = rejectInquiryShown(bidsSaved, bidsSent, isRejected);
     
    const deadlineData = getDeadlineData(newDeadline, timezone);
    const { deadline, deadlineString, deadlineColor, isDeadlineNear } = deadlineData;
    const teamLabel = (
      <>
        <Icon type="team"></Icon> {this.state.teamName}
      </>
    );
    const accessIcons = [<Icon type="global" />, <Icon type="user" />, <Icon type="team" />];
    return (
      <div style={{ display: 'flex', width: '100%', justifyContent: 'space-between' }}>
        <div style={{ padding: '12px 24px 16px', display: 'flex', width: '100%' }}>
          <div>
            <div style={{ display: 'flex', columnGap: '10px', alignItems: 'center' }}>
              <div
                style={{
                  fontWeight: 'bold',
                  fontSize: `${tokens.fontSize.h2}px`,
                }}
              >
                {' '}
                {referenceNumber}
              </div>
              {otherDetails?.isHighValueInsuranceRequired ? <div className={classes.highValue}>High Value Cargo</div> : null}
            </div>
            <div style={{ fontSize: `${tokens.fontSize.small}px`, display: 'flex', width: 'max-content' }}>
              {internalReferenceNumber ? (
                <Tooltip title={internalReferenceNumber}>
                  <div>
                    Internal# {internalReferenceNumber}
                  </div>
                </Tooltip>
              ) : null}
            </div>
            <div style={{ fontSize: `${tokens.fontSize.small}px`, display: 'flex', width: 'max-content', paddingTop: '4px' }}>
              <Tooltip title={isDeadlineNear ? deadline : ''}>
                <Icon
                  type="hourglass"
                  style={{ marginRight: '8px', fontSize: `${tokens.fontSize.body}px`, color: `${deadlineColor}` }}
                />
                <span style={{ color: `${deadlineColor}` }}>{deadlineString}</span>
              </Tooltip>
            </div>
          </div>
          {this.props.type === 'SHIPPER' && (
            <div className={classes.accessTypeDiv}>
              <Select placeholder="Select Access"
               data-testid={'selectAccessDropdown'} 
               onSelect={this.handleAccessTypeChange}
               value={accessType === 'TEAM' ? teamLabel : accessType}
               defaultValue={data.accessorType === 'TEAM' ? teamLabel : data.accessorType}
               disabled={INQUIRY_CREATE_UPDATE_ACTIONS ? false : true}
              >
                      {isDefaultInquiryTeamMapping && userRole !== 'ADMIN' ? (
                        teamMappedAccessKeys?.map((item) => {
                          return (
                            <Select.Option
                              key={item}
                              disabled={
                                (!!visibleAccessTypes.length && !visibleAccessTypes.includes(item)) ||
                                (item === 'TEAM' && teams && !teams.length)
                              }
                            >
                              {accessIcons[item]} {visibleAccessTypeLabelsForTeamMapped[item]}
                            </Select.Option>
                          )
                        })
                      ): (
                        defaultAccessKeys?.map((item) => {
                          return (
                            <Select.Option
                              key={item}
                              disabled={
                                (!!visibleAccessTypes.length && !visibleAccessTypes.includes(item)) ||
                                (item === 'TEAM' && teams && !teams.length)
                              }
                            >
                              {accessIcons[item]} {visibleAccessTypeLabel[item]}
                            </Select.Option>
                          );
                        })
                      )}
                      
                     
                    </Select>
            </div>
          )}
        </div>
        {this.props.type !== 'SHIPPER' && showRejectInquiry && this.renderRejectInquiry()}
        {this.props.type === 'SHIPPER' ? this.renderIcons() : this.renderAddBidButton(data)}
      </div>
    );
  };

  renderAddBidButton = (data) => {
    const { classes } = this.props;
    const permission = this.props.permissions.INQUIRY_BIDDING_ALL_ACTIONS;
    const { status, isRejected, isDeadlinePassed } = data;
    const currentTime = new Date().getTime();
    // const isDeadLinePassed = currentTime - (data.deadline || Number.POSITIVE_INFINITY) >= 0 ? true : false
    const isDeadLinePassed = isDeadlinePassed;
    const isDisabled = isDeadLinePassed || !permission;
    return (
      <div style={{ padding: '12px 12px 12px 0' }}>
        {permission && !isRejected && (
          <Button
            disabled={isDisabled}
            className={isDisabled ? classes.disabledAddBid : classes.addBidBtn}
            type="primary"
            onClick={() => this.handleAddBid(data.id)}
          >
            Add Bid
          </Button>
        )}
      </div>
    );
  };

  getContainerType(key) {
    const { containerTypes } = this.props;
    if (!key || !containerTypes) return;
    const type = containerTypes.filter((item) => item.key === key);
    if (type.length > 0) return type[0].label;
  }

  getContainerDetails = (inquiryFFDetails) => {
    /**
     * This funtion returns:
     * '-' : when container details are not available,
     * Container Details : in case of FCL
     * 'Yes/No' (stackable or not) in case other than FCL i.e. LCL and AIRCARGO.
     */
    if (!inquiryFFDetails) return '-';

    const { mode, containerDetails, stackable } = inquiryFFDetails;
    if (mode === 'FCL') {
      if (!inquiryFFDetails.containerDetails?.length) return '-';

      return containerDetails.map((container, index) => (
        <div key={index}>{this.createPackageEntry(mode, container)}</div>
      ));
    }

    return stackable === null ? 'N/A' : stackable ? 'Yes' : 'No';
  };

  getHaulage = (key) => {
    const { haulage } = this.props;
    const haulageObj = haulage?.find((item) => item.key === key);
    return haulageObj?.label;
  };

  buildFieldLabelMap = (mode: InquiryModes) => {

    const { inquiryDefaultFormConfig } = this.props;

    if (!mode || !inquiryDefaultFormConfig?.isCustomfieldNameEnabledForFF) {
      return {};
    }
    const fieldConfigs = inquiryDefaultFormConfig?.[mode];

    return buildInquiryFieldLabelMap(fieldConfigs);
  };

  getPortLabel = (location, port) => {
    let label = '-';
    if (location?.countryName) label = location.countryName;
    if (port?.code) label = `${port.name}, ${port.code}`;
    if (port?.type === 'DRY') label += ' (ICD)';
    return label;
  };

  renderStakeholderDetails(classes, inquiryFFDetails) {
    const { stakeholder, customer, type } = inquiryFFDetails;
    
    // Determine stakeholder label based on inquiry type
    const stakeholderLabel = type === 'EXPORT' ? 'Shipper' : 'Supplier';
    
    return (
      <Row gutter={24} style={{ paddingBottom: '15px' }}>
        <Col span={4}>
          <div className={classes.detailsTitle}>Stakeholder Details</div>
        </Col>
        <Col span={20}>
          <Row style={{ padding: '5px 0px' }}>
            <Col span={3} className={classes.label}>
              {resolveFieldLabel('grid#stakeholder', stakeholderLabel, this.state.inquiryFieldLabelMap)}
            </Col>
            <Col span={9} className={classes.labelInfo} style={{ paddingLeft: '15px' }}>
              {stakeholder?.name || '-'}
            </Col>
            <Col span={4} className={classes.label} style={{ paddingLeft: '10px' }}>
              {resolveFieldLabel('grid#customer', 'Customer', this.state.inquiryFieldLabelMap)}
            </Col>
            <Col span={8} className={classes.labelInfo} style={{ paddingLeft: '7px' }}>
              {customer?.name || '-'}
            </Col>
          </Row>
        </Col>
      </Row>
    );
  }

  renderInquiryBasicDetails(classes, inquiryFFDetails) {
    const {
      originPortDetails,
      destinationPortDetails,
      origin,
      destination,
      preferredOriginPortDetails,
      preferredDestinationPortDetails,
      mode,
    } = inquiryFFDetails;
    const customFields = this.props.customFieldsForInquiry?.[inquiryFFDetails.mode] || {};
    const originLabel = this.getPortLabel(origin, originPortDetails);
    const destinationLabel = this.getPortLabel(destination, destinationPortDetails);

    const preferredWetPortLabel = (
      <span className={classes.additionalPortDetails} style={{ marginLeft: '5px' }}>
        Preferred Wet Port
      </span>
    );
    return (
      <Row gutter={24} style={{ paddingBottom: '15px' }}>
        <Col span={4}>
          <div className={classes.detailsTitle}>{resolveFieldLabel('#BasicDetails', 'Basic Details', this.state.inquiryFieldLabelMap)}</div>
        </Col>
        <Col span={20}>
          <Timeline className={classes.antTimeline}>
            <Timeline.Item dot={<div className={[classes.dot, classes.dotFilled].join(' ')}></div>}>
              <Row style={{ padding: '5px 0px' }}>
                <Col span={3} className={classes.label}>
                {resolveFieldLabel('grid#originPort', 'Origin', this.state.inquiryFieldLabelMap)}
                </Col>
                <Col span={9} className={classes.labelInfo}>
                {originLabel}
                  {preferredOriginPortDetails ? (
                    <div style={{ marginTop: '10px' }}>
                      <span>{preferredOriginPortDetails.name}</span>
                      {preferredWetPortLabel}
                    </div>
                  ) : (
                    ''
                  )}
                  {origin?.haulage && (
                    <div className={classes.additionalPortDetails} style={{ marginTop: '8px' }}>
                      Haulage: {this.getHaulage(origin?.haulage)}
                    </div>
                  )}
                </Col>
                <Col span={4} className={classes.label}>
                {resolveFieldLabel('grid#cargoAndProduct', 'Cargo & Product', this.state.inquiryFieldLabelMap)}
                </Col>
                <Col span={8} className={classes.labelInfo}>
                  {inquiryFFDetails && inquiryFFDetails.cargoType
                    ? `${prettifyString(inquiryFFDetails.cargoType)}, ${inquiryFFDetails.productType
                    }
                    ${inquiryFFDetails?.temperatureControlled
                      ? ` | ${inquiryFFDetails?.temperatureControlled}°C`
                      : ''
                    }`
                    : '-'}
                </Col>
              </Row>
            </Timeline.Item>
            <Timeline.Item
              dot={<div className={classes.dot}></div>}
              style={{ paddingBottom: '0px' }}
            >
              <Row style={{ padding: '5px 0px' }}>
                <Col span={3} className={classes.label}>
                {resolveFieldLabel('grid#destinationPort', 'Destination', this.state.inquiryFieldLabelMap)}
                </Col>
                <Col span={9} className={classes.labelInfo}>
                {destinationLabel}
                  {preferredDestinationPortDetails ? (
                    <div style={{ marginTop: '10px' }}>
                      <span>{preferredDestinationPortDetails.name}</span>
                      {preferredWetPortLabel}
                    </div>
                  ) : (
                    ''
                  )}
                  {destination?.haulage && (
                    <div className={classes.additionalPortDetails} style={{ marginTop: '8px' }}>
                      Haulage: {this.getHaulage(destination?.haulage)}
                    </div>
                  )}
                </Col>
                <Col span={4} className={classes.label}>
                  {inquiryFFDetails.mode === 'FCL' ? resolveFieldLabel('grid#containerDetails', 'Container Details', this.state.inquiryFieldLabelMap):
                   resolveFieldLabel('grid#Stackable', 'Stackable', this.state.inquiryFieldLabelMap)}
                </Col>
                <Col span={8} className={classes.labelInfo}>
                  {this.getContainerDetails(inquiryFFDetails)}
                </Col>
                {(
                  customFields?.isTiltable || inquiryFFDetails?.otherDetails?.hasOwnProperty('isTiltable')
                ) && <>
                    <Col span={3} className={classes.label}></Col>
                    <Col span={9} className={classes.labelInfo}></Col>
                    <Col span={4} className={classes.label} style={{marginTop: '10px'}}>
                      {customFields?.isTiltable?.prettyName || resolveFieldLabel('grid#tiltable','Tiltable',this.state.inquiryFieldLabelMap)}
                    </Col>
                    <Col span={8} className={classes.labelInfo} style={{marginTop: '10px'}}>
                      {this.props.booking ? (inquiryFFDetails.isTiltable ? 'Yes' : 'No')
                      : (inquiryFFDetails?.otherDetails?.isTiltable === null 
                        ? 'N/A' :
                        inquiryFFDetails?.otherDetails?.isTiltable ? 'Yes' : 'No')}
                    </Col>
                  </>
                }
              </Row>
            </Timeline.Item>
          </Timeline>
        </Col>
      </Row>
    );
  }

  renderInttraBasicDetails(classes, inttraBookingDetails) {
    const {
      originPortDetails,
      destinationPortDetails,
      carrierDetails,
      origin,
      destination,
      portOfLoading: preferredOriginPortDetails,
      portOfDischarge: preferredDestinationPortDetails,
    } = inttraBookingDetails;
    return (
      <Row gutter={24} style={{ paddingBottom: '15px' }}>
        <Col span={4}>
          <div className={classes.detailsTitle}>Basic Details</div>
        </Col>
        <Col span={20}>
          <Timeline className={classes.antTimeline}>
            <Timeline.Item dot={<div className={[classes.dot, classes.dotFilled].join(' ')}></div>}>
              <Row style={{ padding: '5px 0px' }}>
                <Col span={3} className={classes.label}>
                  Origin
                </Col>
                <Col span={9} className={classes.labelInfo}>
                  {originPortDetails ? (
                    <div>{`${originPortDetails.name}, ${originPortDetails.code}
                      ${originPortDetails.type === 'DRY' ? '(ICD)' : ''}`}</div>
                  ) : (
                    '-'
                  )}
                  {preferredOriginPortDetails && originPortDetails.type === 'DRY' && (
                    <div style={{ marginTop: '10px' }}>
                      <span>{preferredOriginPortDetails.name}</span>
                      <span className={classes.additionalPortDetails} style={{ marginLeft: '5px' }}>
                        POL
                      </span>
                    </div>
                  )}
                  {origin?.haulage && (
                    <div className={classes.additionalPortDetails} style={{ marginTop: '8px' }}>
                      Haulage: {this.getHaulage(origin?.haulage)}
                    </div>
                  )}
                </Col>
                <Col span={12}>
                  <Row style={{ marginBottom: '28px' }}>
                    <Col span={8} className={classes.label}>
                      Shipping Line
                    </Col>
                    <Col span={16} className={classes.labelInfo}>
                      {carrierDetails?.name || '-'}
                    </Col>
                  </Row>
                  <Row>
                    <Col span={8} className={classes.label}>
                      Cargo & Product
                    </Col>
                    <Col span={16} className={classes.labelInfo}>
                      {inttraBookingDetails?.cargoType
                        ? `${prettifyString(inttraBookingDetails.cargoType)}, ${inttraBookingDetails.productType
                        }`
                        : '-'}
                    </Col>
                  </Row>
                </Col>
              </Row>
            </Timeline.Item>
            <Timeline.Item
              dot={<div className={classes.dot}></div>}
              style={{ paddingBottom: '0px' }}
            >
              <Row style={{ padding: '5px 0px' }}>
                <Col span={3} className={classes.label}>
                  Destination
                </Col>
                <Col span={9} className={classes.labelInfo}>
                  {destinationPortDetails ? (
                    <div>{`${destinationPortDetails.name}, ${destinationPortDetails.code}
                      ${destinationPortDetails.type === 'DRY' ? '(ICD)' : ''}`}</div>
                  ) : (
                    '-'
                  )}
                  {preferredDestinationPortDetails && destinationPortDetails.type === 'DRY' && (
                    <div style={{ marginTop: '10px' }}>
                      <span>{preferredDestinationPortDetails.name}</span>
                      <span className={classes.additionalPortDetails} style={{ marginLeft: '5px' }}>
                        POD
                      </span>
                    </div>
                  )}
                  {destination?.haulage && (
                    <div className={classes.additionalPortDetails} style={{ marginTop: '8px' }}>
                      Haulage: {this.getHaulage(destination?.haulage)}
                    </div>
                  )}
                </Col>
                <Col span={4} className={classes.label}>
                  {inttraBookingDetails.mode === 'FCL' ? 'Container Details' : 'Stackable'}
                </Col>
                <Col span={8} className={classes.labelInfo}>
                  {this.getContainerDetails(inttraBookingDetails)}
                </Col>
              </Row>
            </Timeline.Item>
          </Timeline>
        </Col>
      </Row>
    );
  }

  createPackageEntry = (mode, container) => {
    switch (mode) {
      case 'FCL':
        return this.getFCLContainerEntry(container);
      case 'LCL':
        return this.getLclPackageEntry(container);
      case 'AIRCARGO':
        return this.getAirCargoPackageEntry(container);
      default:
        return null;
    }
  };

  getFCLContainerEntry = (container) => {
    const { count, type, size, weight, temperature, carriageTemperature, packageDimension } = container;
    const TYPE = this.getContainerType(type);
    const WEIGHT = weight ? `${weight.value} ${weight.unit}` : '';
    const CARRIAGE_TEMPERATURE= isValidNumber(carriageTemperature) ? `${carriageTemperature} °C` : '';
    let DIMENSION;
    

    if (!isEmpty(packageDimension)) {
      const { length, breadth, height, unit } = packageDimension;
      DIMENSION = `${length} x ${breadth} x ${height} ${unit}`;
    }

    return `${count} X ${size} ${TYPE} ${WEIGHT ? ` | ${WEIGHT}` : ''} ${CARRIAGE_TEMPERATURE ? ` | ${CARRIAGE_TEMPERATURE}` : ''}
      ${DIMENSION ? ` | ${DIMENSION}` : ''}`;
  };

  getLclPackageEntry = (container) => {
    const { lclPackageTypes } = this.props;
    const {
      count,
      type,
      packageDimension,
      volume: { value: volume, unit: volumeUnit },
      weight: { value: weight, unit: weightUnit },
    } = container;
    const TYPE = lclPackageTypes[type];
    const VOLUME = `${volume.toFixed(2)} ${volumeUnit}`;
    const WEIGHT = `${weight.toFixed(2)}${weightUnit}`;

    if (!packageDimension) {
      return '-';
    }

    const { length, breadth, height, unit } = packageDimension;
    const DIMENSION = `${length} x ${breadth} x ${height} ${unit}`;
    return DIMENSION;
  };

  getGrossWeightObject = (container) => {
    const weightKey = container.hasOwnProperty('weight') ? 'weight' : 'totalWeight';
    const weightValue =
      weightKey === 'weight'
        ? container.count * container[weightKey]?.value
        : container[weightKey]?.value;
    const weightUnit = container[weightKey]?.unit;
    return {
      weightKey,
      weightUnit,
      weightValue,
    };
  };

  getTotalVolumeObject = (containerDetails) => {
    let totalVolumeUnitMap = {};
    containerDetails?.map(container => {
      const volumeObject = container?.volume || container?.totalVolume;
      const volume = container.count * volumeObject?.value;
        totalVolumeUnitMap = {
          ...totalVolumeUnitMap,
          [volumeObject?.unit]: totalVolumeUnitMap[volumeObject?.unit] ?
            totalVolumeUnitMap[volumeObject?.unit] + volume :
            volume,
        }
    });
    return totalVolumeUnitMap;
  };

  getAirCargoPackageEntry = (container) => {
    const { airCargoPackageTypes } = this.props;
    const { weightKey } = this.getGrossWeightObject(container);
    const {
      type,
      packageDimension,
      volume: { value: volume, unit: volumeUnit },
      [weightKey]: { value: weight, unit: weightUnit },
    } = container || {};
    const { length, breadth, height, unit } = packageDimension || {}
    const DIMENSION = (length && breadth && height && unit) ? `${length} x ${breadth} x ${height} ${unit}` : '-';
    return DIMENSION;
  };

  getPackageDetails = (inquiryFFDetails) => {
    return inquiryFFDetails.containerDetails.map((container, index) => {
      const { mode } = inquiryFFDetails;
      const { volumetricWeight: vW } = container;
      const extraInfo =
        mode === 'AIRCARGO' ? (
          <em style={{ fontWeight: 'normal' }}>
            (Volumetric wt {vW.value.toFixed(2)} {vW.unit})
          </em>
        ) : null;
      return (
        <div
          key={index}
          style={{
            fontWeight: tokens.fontWeight.semibold,
            ...(index > 0 ? { marginTop: '8px' } : {}),
          }}
        >
          {this.createPackageEntry(mode, container)}
          {extraInfo}
        </div>
      );
    });
  };

  renderPackagingDetails = (classes, inquiryFFDetails) => {
    /**
     * this function returns:
     * null: In case of FCL
     * packaging details, otherwise, i.e. LCL and AIRCARGO
     */
    if (
      !inquiryFFDetails ||
      inquiryFFDetails.mode === 'FCL' ||
      !inquiryFFDetails.containerDetails ||
      !inquiryFFDetails.containerDetails.length
    ) {
      return null;
    }

    const { containerDetails, mode } = inquiryFFDetails;
    const packageDetailsHeaders = [
      {
        span: 3,
        key: 'Type',
      },
      {
        span: 4,
        key: 'Dimensions',
      },
      {
        span: 4,
        key: 'Volume',
        alignCenter: true,
      },
      {
        span: 4,
        key: 'Quantity',
        alignCenter: true,
      },
      {
        span: 4,
        key: 'Total Gr. Weight',
        alignCenter: true,
      },
    ];
    if (mode === 'AIRCARGO') {
      packageDetailsHeaders.push({
        span: 4,
        key: 'Total Vol. Weight',
        alignCenter: true,
      });
    }

    const totalVolumeUnitMap = this.getTotalVolumeObject(containerDetails);

    return (
      <>
        <Row gutter={24} style={{ padding: '15px 0px', marginBottom: '15px' }}>
          <Col span={4}>
            <div className={classes.detailsTitle}>{resolveFieldLabel('grid#packagingDetails', 'Packaging Details', this.state.inquiryFieldLabelMap)}</div>
          </Col>
          <Col span={20}>
            <Row>
              {packageDetailsHeaders.map((header) => {
                return (
                  <Col
                    span={header.span}
                    style={{
                      ...(header.alignCenter && {
                        textAlign: 'center',
                      }),
                    }}
                  >
                    {header.key}
                  </Col>
                );
              })}
            </Row>
            {containerDetails?.map((item, index) => {
              const { weightKey, weightValue, weightUnit } = this.getGrossWeightObject(item);
              return (
                <Row
                  key={index}
                  style={{
                    color: '#262626',
                    fontSize: `${tokens.fontSize.body}px`,
                    fontWeight: tokens.fontWeight.semibold,
                    ...(index === 0 && { marginTop: '10px' }),
                  }}
                >
                  <Col span={3}>{prettifyString(item.otherType? item.type + ', ' + item.otherType : item.type)}</Col>
                  <Col span={4}>{this.createPackageEntry(mode, item)}</Col>
                  <Col span={4} style={{ textAlign: 'center' }}>
                    {`${item?.volume?.value?.toFixed(2)} ${item?.volume?.unit}`}
                  </Col>
                  <Col span={4} style={{ textAlign: 'center' }}>
                    {item.count}
                  </Col>
                  <Col span={4} style={{ textAlign: 'center' }}>
                    {`${weightValue?.toFixed(2)}
                  ${weightUnit}`}
                  </Col>
                  {mode === 'AIRCARGO' && (
                    <Col span={4} style={{ textAlign: 'center' }}>
                      {`${(item?.count * item?.volumetricWeight?.value)?.toFixed(2)}
                    ${item?.volumetricWeight?.unit}`}
                    </Col>
                  )}
                </Row>
              );
            })}
            <Row style={{ marginTop: '15px' }}>
              <Col span={3}></Col>
              <Col span={4}
                style={{
                  color: '#262626',
                  fontSize: `${tokens.fontSize.h3}px`,
                  fontWeight: tokens.fontWeight.semibold,
                  textAlign: 'right',
                  paddingRight: '17px',
                }}
              >
                Total
              </Col>
              <Col
                span={4}
                style={{
                  backgroundColor: '#F5F5F5',
                  padding: '5px 0px',
                  textAlign: 'center',
                  marginRight: '3px',
                }}
              >
                {Object.keys(totalVolumeUnitMap)?.map(unit => (
                  <div>
                    {totalVolumeUnitMap[unit]?.toFixed(2)} {unit}
                  </div>
                ))}
              </Col>
              <Col
                span={4}
                style={{
                  backgroundColor: '#F5F5F5',
                  padding: '5px 0px',
                  textAlign: 'center',
                  marginRight: '3px',
                }}
              >
                {containerDetails
                  ?.map((container) => container.count)
                  ?.reduce((total, count) => total + count)}
              </Col>
              <Col
                span={4}
                style={{
                  backgroundColor: '#F5F5F5',
                  padding: '5px 0px',
                  textAlign: 'center',
                  marginRight: '3px',
                }}
              >
                {uniqArray(
                  containerDetails?.map((container) => {
                    const { weightUnit } = this.getGrossWeightObject(container);
                    return weightUnit;
                  })
                )?.map((unit) => {
                  return (
                    <div>{`${containerDetails
                      ?.map((container) => {
                        const { weightKey, weightUnit, weightValue } = this.getGrossWeightObject(
                          container
                        );
                        return weightUnit === unit && weightValue;
                      })
                      ?.reduce((total, grossWeight) => total + grossWeight)
                      ?.toFixed(2)} ${unit}`}</div>
                  );
                })}
              </Col>
              {mode === 'AIRCARGO' && (
                <Col
                  span={4}
                  style={{ backgroundColor: '#F5F5F5', padding: '5px 0px', textAlign: 'center' }}
                >
                  {`${containerDetails
                    .map((container) => container.count * container.volumetricWeight.value)
                    .reduce((total, weight) => total + weight)
                    .toFixed(2)} kg`}
                </Col>
              )}
            </Row>
          </Col>
        </Row>
        {this.renderDivider()}
      </>
    );
  };

  renderDivider() {
    return <Divider style={{ marginTop: '0', marginBottom: '15px' }} />;
  }

  renderInquiryOtherDetails(classes, inquiryFFDetails) {
    let inquiryType = inquiryFFDetails && inquiryFFDetails.type ? inquiryFFDetails.type : '';
    inquiryType = inquiryType.charAt(0).toUpperCase() + inquiryType.slice(1).toLowerCase();
    const customFields = this.props.customFieldsForInquiry?.[inquiryFFDetails.mode] || {};
    return (
      <Row gutter={24} style={{ padding: '15px 0px' }}>
        <Col span={4}>
          <div className={classes.detailsTitle}> {resolveFieldLabel('grid#otherDetails', 'Other Details', this.state.inquiryFieldLabelMap)}
          </div>
        </Col>
        <Col span={20}>
          <Row style={{ padding: '3px 0px' }}>
            <Col span={4} className={classes.label}>
              {
                // TODO(code-cleanup): Find a way to replace these conditional for cleaner code!
                inquiryFFDetails.mode === 'AIRCARGO'
                  ? resolveFieldLabel('grid#preferredFlyingRange', 'Preferred Flying Range', this.state.inquiryFieldLabelMap)
                  : resolveFieldLabel('grid#preferredSailingRange', 'Preferred Sailing Range', this.state.inquiryFieldLabelMap)
              }
            </Col>
            <Col span={8} className={classes.labelInfo} style={{ paddingLeft: '15px' }}>
              {inquiryFFDetails &&
                inquiryFFDetails.preferredSailingRange &&
                inquiryFFDetails.preferredSailingRange[0] &&
                inquiryFFDetails.preferredSailingRange[1]
                ? `${moment(inquiryFFDetails.preferredSailingRange[0]).format('DD MMM YYYY')} -
                  ${moment(inquiryFFDetails.preferredSailingRange[1]).format('DD MMM YYYY')}`
                : '-'}
            </Col>
            <Col span={4} className={classes.label} style={{ paddingLeft: '10px' }}>
            {resolveFieldLabel('grid#pickup&drop', 'Pickup & Drop', this.state.inquiryFieldLabelMap)}
            </Col>
            <Col span={8} className={classes.labelInfo} style={{ paddingLeft: '7px' }}>
              {inquiryFFDetails && inquiryFFDetails.pickupAndDrop
                ? inquiryFFDetails.pickupAndDrop
                : '-'}
              {inquiryFFDetails?.origin?.movementType && (
                <div style={{ fontWeight: 'normal', marginTop: '4px' }}>
                  <span className={classes.additionalPortDetails}>
                  {resolveFieldLabel('grid#pickup&dropOrigin', 'Origin', this.state.inquiryFieldLabelMap)}: {this.getHaulage(inquiryFFDetails?.origin?.movementType)}
                  </span>
                </div>
              )}
              {inquiryFFDetails?.destination?.movementType && (
                <div style={{ fontWeight: 'normal', marginTop: '4px' }}>
                  <span className={classes.additionalPortDetails}>
                  {resolveFieldLabel('grid#pickup&dropDestination', 'Destination', this.state.inquiryFieldLabelMap)}: {this.getHaulage(inquiryFFDetails?.destination?.movementType)}
                  </span>
                </div>
              )}
            </Col>
          </Row>
          <Row style={{ padding: '5px 0px', margin: '20px 0px' }}>
            <Col span={4} className={classes.label}>
            {resolveFieldLabel('grid#cargoReadyDate', 'Cargo Ready Date', this.state.inquiryFieldLabelMap)}
            </Col>
            <Col span={8} className={classes.labelInfo} style={{ paddingLeft: '15px' }}>
              {inquiryFFDetails && inquiryFFDetails.cargoReadyDate
                ? `${moment(inquiryFFDetails.cargoReadyDate).format('DD MMM YYYY')}`
                : '-'}
            </Col>
          </Row>
          {inquiryFFDetails?.mode === "FCL" ? 
          (<Row style={{ padding: '5px 0px', margin: '20px 0px' }}>
            <Col span={4} className={classNames(classes.label, classes.requiredOriginFreeDays)}>
            {resolveFieldLabel('grid#requiredOriginFreeDays', 'Required Origin Free Days', this.state.inquiryFieldLabelMap)}
            </Col>
            <Col span={8} className={classes.labelInfo} style={{ paddingLeft: '15px' }}>
              {inquiryFFDetails?.requiredOriginFreeDays ?? '-'}
            </Col>
            <Col span={4} className={classNames(classes.label, classes.destinationFreeDays)}>
            {resolveFieldLabel('grid#requiredDestinationFreeDays', 'Required Destination Free Days', this.state.inquiryFieldLabelMap)}
            </Col>
            <Col span={8} className={classes.labelInfo} style={{ paddingLeft: '7px' }}>
              {inquiryFFDetails?.requiredDestinationFreeDays ?? '-'}
            </Col>
          </Row>)
          : null}
          <Row style={{ padding: '5px 0px', margin: '20px 0px' }}>
            <Col span={4} className={classes.label}>
            {resolveFieldLabel('grid#MovementType', 'Type', this.state.inquiryFieldLabelMap)}
            </Col>
            <Col span={8} className={classes.labelInfo} style={{ paddingLeft: '15px' }}>
              {inquiryFFDetails && inquiryFFDetails.type ? inquiryType : '-'}
            </Col>
            <Col span={4} className={classNames(classes.label, classes.destinationFreeDays)}>
            {resolveFieldLabel('grid#productDetails', 'Product Details', this.state.inquiryFieldLabelMap)}
            </Col>
            <Col span={8} className={classes.labelInfo} style={{ paddingLeft: '7px' }}>
              {inquiryFFDetails?.productList && inquiryFFDetails?.productList.length > 0 ? (
                <Tooltip
                  title={inquiryFFDetails?.productList
                    .filter(product => product) // Filter out null/undefined products
                    .map((product) => {
                      // Safely construct the description
                      const parts: string[] = [];
                      if (product?.hsCode) parts.push(product.hsCode);
                      if (product?.description) parts.push(product.description);
                      return parts.join(' - ');
                    })
                    .filter(desc => desc) // Filter out empty descriptions
                    .join(', ')}
                >
                  <div>
                    {inquiryFFDetails?.productList
                      .filter(product => product) // Filter out null/undefined products
                      .map((product, index, array) => (
                        <span key={index}>
                          {product.count ? `${product.count} X ` : ''}
                          {product.internalName ? `${product.internalName} ` : ''}
                          {product.referenceNumber ? `[${product.referenceNumber}] ` : ''}
                          {product.unit || ''}
                          {index < array.length - 1 ? ', ' : ''}
                        </span>
                      ))}
                  </div>
                </Tooltip>
              ) : (
                '-'
              )}
            </Col>

          </Row>
          <Row style={{ padding: '5px 0px', margin: '20px 0px' }}>
            <Col span={4} className={classes.label}>
            {resolveFieldLabel('grid#incotermType', 'Incoterm', this.state.inquiryFieldLabelMap)}
            </Col>
            <Col span={8} className={classes.labelInfo} style={{ paddingLeft: '15px' }}>
              {inquiryFFDetails && inquiryFFDetails.incoterm ? inquiryFFDetails.incoterm : '-'}
            </Col>
            <Col span={4} className={classNames(classes.label, classes.destinationFreeDays)}>
              {inquiryFFDetails.mode === 'AIRCARGO'
                ? resolveFieldLabel('grid#preferredMode', 'Preferred Air Carrier', this.state.inquiryFieldLabelMap)
                : resolveFieldLabel('grid#preferredMode', 'Preferred Shipping Line', this.state.inquiryFieldLabelMap)
              }
            </Col>
            <Col span={8} className={classes.labelInfo} style={{ paddingLeft: '7px' }}>
              {inquiryFFDetails?.preferredCarriers
                ?.map((line) => {
                  return line;
                })
                .join(', ') || 'All'}
            </Col>
          </Row>
          {this.props.enableDispatchMode && (
            <Row style={{ padding: '5px 0px', margin: '20px 0px' }}>
              <Col span={4} className={classes.label}>
                {resolveFieldLabel('grid#dispatchMode', 'Dispatch Mode', this.state.inquiryFieldLabelMap)}
              </Col>
              <Col span={8} className={classes.labelInfo} style={{ paddingLeft: '15px' }}>
                {inquiryFFDetails && inquiryFFDetails.dispatchMode
                  ? (DISPATCH_MODE_LABELS[inquiryFFDetails.dispatchMode] || inquiryFFDetails.dispatchMode)
                  : '-'}
              </Col>
            </Row>
          )}
          <Row style={{ padding: '5px 0px', margin: '20px 0px' }}>
            {(
              customFields?.shipmentName || inquiryFFDetails?.otherDetails?.hasOwnProperty('shipmentName')
            ) && <>
              <Col span={4} className={classes.label}>
                {customFields?.shipmentName?.prettyName ||resolveFieldLabel('grid#shipmentName', 'Shipment Name', this.state.inquiryFieldLabelMap)}
                </Col>
                <Col span={8} className={classes.labelInfo} style={{ paddingLeft: '15px' }}>
                {inquiryFFDetails?.otherDetails?.shipmentName || '-'}
                </Col>
              </>
            }
            {(
              customFields?.requestor || inquiryFFDetails?.otherDetails?.hasOwnProperty('requestor')
            ) && <>
              <Col span={4} className={classNames(classes.label, classes.destinationFreeDays)}>
                {customFields?.requestor?.prettyName || resolveFieldLabel('grid#requestor', 'Requestor', this.state.inquiryFieldLabelMap)}
                </Col>
                <Col span={8} className={classes.labelInfo} style={{ paddingLeft: '7px' }}>
                  {inquiryFFDetails?.otherDetails?.requestor || '-'}
                </Col>
              </>
            }
          </Row>
          <Row style={{ padding: '5px 0px', margin: '20px 0px' }}>
            {(
              customFields?.serviceLevel || inquiryFFDetails?.otherDetails?.hasOwnProperty('serviceLevel')
            ) && <>
              <Col span={4} className={classes.label}>
                {customFields?.serviceLevel?.prettyName || 'Service Level'}
                </Col>
                <Col span={8} className={classes.labelInfo} style={{ paddingLeft: '15px' }}>
                {inquiryFFDetails?.otherDetails?.serviceLevel || '-'}
                </Col>
              </>
            }
            {(
              customFields?.typeOfMovement || inquiryFFDetails?.otherDetails?.hasOwnProperty('typeOfMovement')
            ) && <>
              <Col span={4} className={classNames(classes.label, classes.destinationFreeDays)}>
                {customFields?.typeOfMovement?.prettyName || 'Type of Import/Export'}
                </Col>
                <Col span={8} className={classes.labelInfo} style={{ paddingLeft: '7px' }}>
                {inquiryFFDetails?.otherDetails?.typeOfMovement || '-'}
                </Col>
              </>
            }
          </Row>
           <Row style={{ padding: '5px 0px', margin: '20px 0px' }}>
            {(
              customFields?.typeOfContainer || inquiryFFDetails?.otherDetails?.hasOwnProperty('typeOfContainer')
            ) && <>
              <Col span={4} className={classes.label}>
                {customFields?.typeOfContainer?.prettyName || 'Type of Container'}
                </Col>
                <Col span={8} className={classes.labelInfo} style={{ paddingLeft: '15px' }}>
                {inquiryFFDetails?.otherDetails?.typeOfContainer || '-'}
                </Col></> 
              }
              {(
                inquiryFFDetails?.otherDetails?.isDraft && (customFields?.remarks || inquiryFFDetails?.otherDetails?.hasOwnProperty('remarks'))
              ) && <>
                <Col span={4} className={classNames(classes.label, classes.destinationFreeDays)}>
                  {customFields?.remarks?.prettyName || 'Remarks'}
                  </Col>
                  <Col span={8} className={classes.labelInfo} style={{ paddingLeft: '7px' }}>
                  {inquiryFFDetails?.otherDetails?.remarks || '-'}
                  </Col>
                </>
              }
            </Row>

          {(inquiryFFDetails.mode === 'FCL' || inquiryFFDetails.mode === 'LCL') && (
            <Row style={{ padding: '5px 0px', margin: '20px 0px' }}>
              <Col span={4} className={classes.label}>
              {resolveFieldLabel('grid#businessType', 'Business Type', this.state.inquiryFieldLabelMap)}
              </Col>
              <Col span={8} className={classes.labelInfo} style={{ paddingLeft: '15px' }}>
                {inquiryFFDetails && inquiryFFDetails?.otherDetails?.businessType ? inquiryFFDetails?.otherDetails?.businessType : '-'}
              </Col>
            </Row>
          )}
          {
            inquiryFFDetails?.otherDetails?.businessEntity && (
              <Row style={{ padding: '5px 0px', margin: '20px 0px' }}>
                <Col span={4} className={classes.label}>
                {resolveFieldLabel('grid#businessEntity', 'Business Entity', this.state.inquiryFieldLabelMap)}
                </Col>
                <Col span={8} className={classes.labelInfo} style={{ paddingLeft: '15px' }}>
                  {inquiryFFDetails?.otherDetails?.businessEntity}
                </Col>
              </Row>
            )
          }
          {(inquiryFFDetails.mode === 'FCL' || inquiryFFDetails.mode === 'LCL') && (
            <Row style={{ padding: '5px 0px', margin: '20px 0px' }}>
              <Col span={4} className={classes.label}>
              {resolveFieldLabel('grid#otherDetails.OtherDetails', 'Other Details', this.state.inquiryFieldLabelMap)}
              </Col>
              <Col span={8} className={classes.labelInfo} style={{ paddingLeft: '15px', width: '80%' }}>
                {inquiryFFDetails && inquiryFFDetails?.otherDetails?.extraDetails ? nl2Br(inquiryFFDetails?.otherDetails?.extraDetails) : '-'}
              </Col>
            </Row>
          )}
          {inquiryFFDetails?.incotermDetails && (
            <Row style={{ padding: '5px 0px', margin: '20px 0px' }}>
              <Col span={4} className={classes.label}>
              {resolveFieldLabel('grid#otherDetails.Details', 'Details', this.state.inquiryFieldLabelMap)}

              </Col>
              <Col span={8} className={classes.labelInfo} style={{ paddingLeft: '15px' }}>
                {nl2Br(inquiryFFDetails.incotermDetails, '\n')}
              </Col>
            </Row>
          )}
        </Col>
      </Row>
    );
  }

  cleanInchargeDetails = (inchargeDetails) => {
    if (!inchargeDetails) return '';
    if (Array.isArray(inchargeDetails)) {
      return inchargeDetails
        .map(contact => {
          const { name, phone, email } = contact;
          return `${name || ''} ${phone || ''} ${email || ''}`.trim();
        })
        .filter(contact => contact !== '')
        .join('; ');
    }
    if (typeof inchargeDetails !== 'string') {
      return '';
    }
    
    // Remove whitespace, tabs, newlines, and filter out 'null' strings
    const cleaned = inchargeDetails
      .split(/\s+/)
      .filter(part => part.trim() !== '' && part.toLowerCase() !== 'null')
      .join(' ')
      .trim();
    
    return cleaned || '';
  };

  getMovementTypeValue = (inttraBookingDetails, inquiryFFDetails): React.ReactElement => {
    const movementTypeForCarrier = inttraBookingDetails?.movementTypeForCarrier;
    switch (movementTypeForCarrier) {
      case 'Port to Door':
        return this.renderMovementTypeValue(
          'Destination',
          inquiryFFDetails?.destination?.movementType
        );
      case 'Door to Port':
        return this.renderMovementTypeValue('Origin', inquiryFFDetails?.origin?.movementType);
      case 'Door to Door':
        return (
          <React.Fragment>
            {this.renderMovementTypeValue('Origin', inquiryFFDetails?.origin?.movementType)}
            {this.renderMovementTypeValue(
              'Destination',
              inquiryFFDetails?.destination?.movementType
            )}
          </React.Fragment>
        );
      default:
        return <div></div>;
    }
  };

  renderMovementTypeValue = (label, movementType) => {
    const { classes } = this.props;
    return (
      <div style={{ fontWeight: 'normal', marginTop: '4px' }}>
        <span className={classes.additionalPortDetails}>
          {label}: {this.getHaulage(movementType)}
        </span>
      </div>
    );
  };

  renderInttraOtherDetails(classes, inquiryFFDetails, inttraBookingDetails) {
    return (
      <Row gutter={24} style={{ padding: '15px 0px' }}>
        <Col span={4}>
          <div className={classes.detailsTitle}>Other Details</div>
        </Col>
        <Col span={20}>
          <Row style={{ padding: '3px 0px' }}>
            <Col span={4} className={classes.label}>
              Estimated Time of Departure
            </Col>
            <Col span={8} className={classes.labelInfo} style={{ paddingLeft: '15px' }}>
              {moment(inttraBookingDetails.estimatedTimeOfDeparture).format('DD MMM YYYY')}
            </Col>
            <Col span={4} className={classes.label} style={{ paddingLeft: '10px' }}>
              Movement Type For Carrier
            </Col>
            <Col span={8} className={classes.labelInfo} style={{ paddingLeft: '7px' }}>
              {inttraBookingDetails?.movementTypeForCarrier || '-'}
              {this.getMovementTypeValue(inttraBookingDetails, inquiryFFDetails)}
            </Col>
          </Row>
          <Row style={{ padding: '5px 0px', margin: '20px 0px' }}>
            <Col span={4} className={classes.label}>
              Type
            </Col>
            <Col span={8} className={classes.labelInfo} style={{ paddingLeft: '15px' }}>
              {inquiryFFDetails?.type ? prettifyString(inquiryFFDetails.type) : '-'}
            </Col>
            <Col span={4} className={classNames(classes.label, classes.destinationFreeDays)}>
              Product Details
            </Col>
            <Col span={8} className={classes.labelInfo} style={{ paddingLeft: '7px' }}>
              {inttraBookingDetails.productDetails
                ? `${inttraBookingDetails.productDetails.hsCode} | ${inttraBookingDetails.productDetails.name}`
                : '-'}
            </Col>
          </Row>
        </Col>
      </Row>
    );
  }

  renderInquiryLocationDetails(classes, inquiryFFDetails) {
    const { origin, destination } = inquiryFFDetails;
    return (
      <Row gutter={24} style={{ padding: '15px 0px' }}>
        <Col span={4}>
          <div className={classes.detailsTitle}>Location Details</div>
        </Col>
        <Col span={20}>
          <Timeline className={classes.antTimeline}>
            <Timeline.Item dot={<div className={[classes.dot, classes.dotFilled].join(' ')}></div>}>
              <Row style={{ padding: '5px 0px' }}>
                <Col span={4} className={classes.label}>
                {resolveFieldLabel('grid#additionalDetails.originCountry', 'Origin Country', this.state.inquiryFieldLabelMap)}
                </Col>
               
                <Col span={8} className={classes.labelInfo}> 
                  {origin?.countryName ? <div>{origin?.countryName}</div> : '-'}
                  {origin?.address ? (
                    <div style={{ marginTop: '10px' }}>{origin?.address} {this.cleanInchargeDetails(origin?.inchargeDetails)}  </div>
                  ) : (
                    ''
                  )}
                </Col>
                <>
                <Col span={4} className={classes.label}>
                {resolveFieldLabel('grid#stuffingLocation', 'Stuffing Location', this.state.inquiryFieldLabelMap)}
                </Col>
                <Col span={8} className={classes.labelInfo}>
                  {inquiryFFDetails.mode !== 'LCL' ? (
                    <>
                      {origin?.location ? origin?.location : '-'}
                      {origin?.location !== 'Dock/CFS/Customs Warehouse' && (
                        <div style={{ marginTop: 16 }}>
                          {origin?.stuffingDestuffingAddress} {this.cleanInchargeDetails(origin?.inchargeDetails)}
                        </div>
                      )}
                    </>
                  ) : (
                    origin?.location || origin?.stuffingDestuffingAddress || '-'
                  )}
                </Col>
              </>
              </Row>
            </Timeline.Item>
            <Timeline.Item
              dot={<div className={classes.dot}></div>}
              style={{ paddingBottom: '0px' }}
            >
              <Row style={{ padding: '5px 0px' }}>
                <Col span={4} className={classes.label}>
                {resolveFieldLabel('grid#additionalDetails.destinationCountry', 'Destination Country', this.state.inquiryFieldLabelMap)}
                </Col>
                <Col span={8} className={classes.labelInfo}>
                  {destination?.countryName ? <div>{destination?.countryName}</div> : '-'}
                  {destination?.address ? (
                    <div style={{ marginTop: '10px' }}>{destination?.address} {this.cleanInchargeDetails(destination?.inchargeDetails)}</div>
                  ) : (
                    ''
                  )}
                </Col>
                <>
                <Col span={4} className={classes.label}>
                {resolveFieldLabel('grid#additionalDetails.destuffingLocation', 'De-Stuffing Location', this.state.inquiryFieldLabelMap)}
                </Col>
                <Col span={8} className={classes.labelInfo}>
                  {inquiryFFDetails.mode !== 'LCL' ? (
                    <>
                      {destination?.location ? destination?.location : '-'}
                      {destination?.location !== 'Dock/CFS/Customs Warehouse' && (
                        <div style={{ marginTop: 16 }}>
                          {destination?.stuffingDestuffingAddress} {this.cleanInchargeDetails(destination?.inchargeDetails)}
                        </div>
                      )}
                    </>
                  ) : (
                    destination?.location || destination?.stuffingDestuffingAddress || '-'
                  )}
                </Col>
              </>
              </Row>
            </Timeline.Item>
          </Timeline>
        </Col>
      </Row>
    );
  }

  renderInquiryServices(classes, inquiryFFDetails) {
    return (
      <Row gutter={24} style={{ padding: '15px 0px' }}>
        <Col span={4}>
          <div className={classes.detailsTitle}>Services</div>
        </Col>
        <Col span={20}>
          <Row style={{ padding: '3px 0px', marginBottom: '20px' }}>
            <Col span={4} className={classes.label}>
            {resolveFieldLabel('grid#originservices', 'Origin Services', this.state.inquiryFieldLabelMap)}
            </Col>
            <Col span={8} className={classes.labelInfo} style={{ paddingLeft: '15px' }}>
              {inquiryFFDetails && inquiryFFDetails.origin && inquiryFFDetails.origin?.services
                ? inquiryFFDetails.origin?.services.map((service, index) => (
                  <div key={index}>{service}</div>
                ))
                : '-'}
            </Col>
            <Col span={4} className={classes.label} style={{ paddingLeft: '10px' }}>
            {resolveFieldLabel('grid#destinatioservices', 'Destination Services', this.state.inquiryFieldLabelMap)}
            </Col>
            <Col span={8} className={classes.labelInfo} style={{ paddingLeft: '7px' }}>
              {inquiryFFDetails &&
                inquiryFFDetails.destination &&
                inquiryFFDetails.destination?.services
                ? inquiryFFDetails.destination?.services.map((service, index) => (
                  <div key={index}>{service}</div>
                ))
                : '-'}
            </Col>
          </Row>
            {(inquiryFFDetails?.origin?.additionalDetails ||
              inquiryFFDetails?.destination?.additionalDetails) && (
              <Row style={{ padding: '3px 0px', marginBottom: '20px' }}>
                {inquiryFFDetails?.origin?.additionalDetails && (
                  <>
                    <Col span={4} className={classes.label}>
                      Details
                    </Col>
                    <Col span={8} className={classes.labelInfo} style={{ paddingLeft: '15px' }}>
                      {nl2Br(inquiryFFDetails.origin?.additionalDetails, '\n')}
                    </Col>
                  </>
                )}
                {!inquiryFFDetails?.origin?.additionalDetails &&
                  inquiryFFDetails?.destination?.additionalDetails && (
                    <>
                      <Col span={4} />
                      <Col span={8} />
                    </>
                  )}
                {inquiryFFDetails?.destination?.additionalDetails && (
                  <>
                    <Col span={4} className={classes.label} style={{ paddingLeft: '10px' }}>
                      Details
                    </Col>
                    <Col span={8} className={classes.labelInfo} style={{ paddingLeft: '7px' }}>
                      {nl2Br(inquiryFFDetails.destination?.additionalDetails, '\n')}
                    </Col>
                  </>
                )}
              </Row>
            )}
        </Col>
      </Row>
    );
  }

  renderInquiryTermsNConditions(classes, inquiryFFDetails) {
    return (
      <Row gutter={24} style={{ padding: '15px 0px' }}>
        <Col span={4}>
          <div className={classes.detailsTitle}>{resolveFieldLabel('grid#defaultTnC', 'Terms & Conditions', this.state.inquiryFieldLabelMap)}</div>
        </Col>
        <Col
          span={20}
          className={classes.labelInfo}
          style={{ marginBottom: '20px', paddingTop: '3px' }}
        >
          {inquiryFFDetails && inquiryFFDetails.termsAndConditions
            ? nl2Br(inquiryFFDetails.termsAndConditions)
            : '-'}
        </Col>
      </Row>
    );
  }

  renderDocuments(classes, inquiryFFDetails) {
    const { allowedDocumentTypes } = this.props;
    const { selectedFileViewer } = this.state;
    
    return (
      <>
        <Row gutter={24} style={{ paddingTop: '15px' }}>
          <Col span={4}>
            <div className={classes.detailsTitle}>Documents</div>
          </Col>
          <Col span={20}>
            <div className={classes.flexColumn} style={{ marginTop: '3px' }}>
              {inquiryFFDetails &&
                inquiryFFDetails.documentUrls &&
                inquiryFFDetails.documentUrls.map((doc, index) => {
                  const documentTitle = allowedDocumentTypes?.[doc?.type] || doc?.type;
                  const fullTitle = `${documentTitle} - ${doc.name}`;
                  
                  return (
                    <div 
                      key={`${doc.url}-${index}`}
                      className={classes.labelInfo} 
                      style={{ 
                        marginBottom: '20px',
                        display: 'flex',
                        alignItems: 'center',
                        gap: '10px'
                      }}
                    >
                      <a
                        href="#"
                        onClick={(e) => {
                          e.preventDefault();
                          this.setState({
                            selectedFileViewer: {
                              url: doc.url,
                              fileName: doc.name,
                              title: fullTitle,
                            }
                          });
                        }}
                        style={{ 
                          color: tokens.colors.primary, 
                          fontSize: `${tokens.fontSize.body}px`, 
                          fontWeight: 'bold',
                          maxWidth: '400px',
                          whiteSpace: 'nowrap',
                          overflow: 'hidden',
                          textOverflow: 'ellipsis',
                          display: 'inline-block'
                        }}
                        title={fullTitle}
                      >
                        <Icon type="file" style={{ marginRight: '5px' }} />
                        {fullTitle}
                      </a>
                      
                      <Tooltip title="Download file">
                        <Button
                          type="link"
                          icon="download"
                          size="small"
                          onClick={() => {
                            const link = window.document.createElement('a');
                            link.href = doc?.url;
                            link.download = doc?.name;
                            window.document.body.appendChild(link);
                            link.click();
                            window.document.body.removeChild(link);
                          }}
                          style={{ 
                            padding: '0 8px',
                            height: '24px',
                            minWidth: 'auto'
                          }}
                        />
                      </Tooltip>
                    </div>
                  );
                })}
            </div>
          </Col>
        </Row>
        
        {selectedFileViewer && (
          <FileViewer
            url={selectedFileViewer.url}
            fileName={selectedFileViewer.fileName}
            title={selectedFileViewer.title}
            onClose={() => this.setState({ selectedFileViewer: null })}
          />
        )}
      </>
    );
  }

  renderReferenceRate(inquiryFFDetails) {
    const { currencySymbols, classes, referenceRateBasis } = this.props;
    const { referenceRate, totalUnits } = inquiryFFDetails;
    return (
      <Row gutter={24} style={{ padding: '15px 0px' }}>
        <Col span={4}>
          <div className={classes.detailsTitle}>{resolveFieldLabel('grid#referenceRate', 'Reference Rate', this.state.inquiryFieldLabelMap)}</div>
        </Col>
        <Col span={20}>
          <Row style={{ padding: '3px 0px', marginBottom: '20px' }}>
            <Col span={4} className={classes.label}>
            {resolveFieldLabel('grid#chargeType', 'Charge Type', this.state.inquiryFieldLabelMap)}
            </Col>
            <Col span={8} className={classes.labelInfo} style={{ paddingLeft: '15px' }}>
              {referenceRate && referenceRate.basis ? referenceRateBasis[referenceRate.basis] : '-'}
            </Col>
            <Col span={4} className={classes.label} style={{ paddingLeft: '10px' }}>
            {resolveFieldLabel('grid#amount', 'Amount', this.state.inquiryFieldLabelMap)}
            </Col>
            <Col span={8} className={classes.labelInfo} style={{ paddingLeft: '7px' }}>
              {referenceRate && referenceRate.currency && referenceRate.amount ? (
                <div>
                  <span style={{ fontSize: tokens.fontSize.caption, verticalAlign: '20%' }}>
                    {currencySymbols[referenceRate.currency]}
                  </span>
                  {Number(referenceRate.amount).toFixed(2)}
                  <span style={{ fontSize: 9, marginLeft: 5 }}>
                    x {Number(totalUnits?.amount || 0).toFixed(2)} {totalUnits?.format}
                  </span>
                  <span style={{ marginLeft: 5 }}>=</span>
                  <span style={{ fontSize: tokens.fontSize.caption, verticalAlign: '20%', marginLeft: 5 }}>
                    {currencySymbols[referenceRate.currency]}
                  </span>
                  {(Number(referenceRate.amount) * Number(totalUnits?.amount || 0)).toFixed(2)}
                </div>
              ) : (
                '-'
              )}
            </Col>
          </Row>
        </Col>
      </Row>
    );
  }

  handleTeamSelect = async (team) => {
    const inquiryId = this.props.match.params.inquiryId;
    const shipperId = this.props.data?.shipperId;
    this.setState({
      accessType: 'TEAM',
      teamId: team.id,
      teamName: `${team.name} (${team.reference_number})`,
      isSelectTeamModalVisible: false,
    });
    const response = await editAccessInInquiryDetails({
      inquiryId,
      accessType: 'TEAM',
      teamId: team.id,
      shipperId,
    });
    if (response.isSuccess) {
      message.success('Inquiry Access Updated Successfully');
    } else {
      message.error(response.errorMessage);
    }
  };

  renderReeferInfo = (label, key) => {
    const { classes } = this.props;
    return (
      <React.Fragment>
        <Col span={4} className={classes.label}>
          {label}
        </Col>
        <Col span={20} className={classes.labelInfo} style={{ paddingLeft: '15px' }}>
          {key}
        </Col>
      </React.Fragment>
    );
  };

  renderAdditionalReeferDetails = () => {
    const { classes } = this.props;
    const { inquiryData, activeTab, inttraBookingDetails } = this.state;
    const reeferAdditionalDetails =
      activeTab === '2'
        ? inttraBookingDetails.productAdditionalDetails
        : inquiryData?.productAdditionalDetails;
    return (
      <Row style={{ padding: '15px 0px' }}>
        <Col span={4}>
          <div className={classes.detailsTitle}>Reefer Product Details</div>
        </Col>
        <Col span={20}>
          <Row style={{ padding: '5px 0px' }}>
            {this.renderReeferInfo(
              'Temperature',
              isValidNumber(reeferAdditionalDetails?.temperatureControlled)
                ? `${reeferAdditionalDetails?.temperatureControlled} °C`
                : '-'
            )}
          </Row>
          <Row style={{ padding: '5px 0px', margin: '20px 0px' }}>
            {this.renderReeferInfo(
              'Relative Humidity',
              isValidNumber(reeferAdditionalDetails?.relativeHumidity)
                ? `${reeferAdditionalDetails?.relativeHumidity}%`
                : '-'
            )}
          </Row>
          <Row style={{ padding: '5px 0px', margin: '20px 0px' }}>
            {this.renderReeferInfo('Vent Details', reeferAdditionalDetails?.ventSetting || '-')}
          </Row>
        </Col>
      </Row>
    );
  };

  renderAdditionalHazDetails = () => {
    const { classes } = this.props;
    const { inquiryData, activeTab, inttraBookingDetails } = this.state;
    const hazAdditionalDetails =
      activeTab === '2'
        ? inttraBookingDetails.productAdditionalDetails
        : inquiryData?.productAdditionalDetails;

    return (
      <Row style={{ padding: '15px 0px' }}>
        <Col span={4}>
          <div className={classes.detailsTitle}>Haz Product Details</div>
        </Col>
        <Col span={20}>
          <Row style={{ padding: '5px 0px' }}>
            <Col span={4} className={classNames(classes.label, classes.destinationFreeDays)}>
              EMS Number
            </Col>
            <Col span={8} className={classes.labelInfo} style={{ paddingLeft: '7px' }}>
              {hazAdditionalDetails?.emsNumber || '-'}
            </Col>
            <Col span={4} className={classes.label} style={{ paddingLeft: '10px' }}>
              UNDG Number
            </Col>
            <Col span={8} className={classes.labelInfo} style={{ paddingLeft: '15px' }}>
              {hazAdditionalDetails?.undgNumber || '-'}
            </Col>
          </Row>
          <Row style={{ padding: '5px 0px', margin: '20px 0px' }}>
            <Col span={4} className={classNames(classes.label, classes.destinationFreeDays)}>
              Packing Group
            </Col>
            <Col span={8} className={classes.labelInfo} style={{ paddingLeft: '7px' }}>
              {hazAdditionalDetails?.packingGroup || '-'}
            </Col>
            <Col span={4} className={classes.label} style={{ paddingLeft: '10px' }}>
              Flash Point - Temp
            </Col>
            <Col span={8} className={classes.labelInfo} style={{ paddingLeft: '15px' }}>
              {hazAdditionalDetails?.flashPointTemp
                ? `${hazAdditionalDetails?.flashPointTemp} °C`
                : '-'}
            </Col>
          </Row>
          <Row style={{ padding: '5px 0px', margin: '20px 0px' }}>
            <Col span={4} className={classNames(classes.label, classes.destinationFreeDays)}>
              Emergency Contact
            </Col>
            <Col span={8} className={classes.labelInfo} style={{ paddingLeft: '7px' }}>
              {this.renderEmergencyContact(hazAdditionalDetails)}
            </Col>
            <Col span={4} className={classes.label} style={{ paddingLeft: '10px' }}>
              Shipping Name
            </Col>
            <Col span={8} className={classes.labelInfo} style={{ paddingLeft: '15px' }}>
              {hazAdditionalDetails?.shippingName || '-'}
            </Col>
          </Row>
          <Row style={{ padding: '5px 0px', margin: '20px 0px' }}>
            {activeTab === '2' && (
              <React.Fragment>
                <Col span={4} className={classes.label} style={{ paddingLeft: '10px' }}>
                  IMO Class
                </Col>
                <Col span={8} className={classes.labelInfo} style={{ paddingLeft: '15px' }}>
                  {hazAdditionalDetails?.imoClassCode || '-'}
                </Col>
              </React.Fragment>
            )}
          </Row>
        </Col>
      </Row>
    );
  };

  getPaymentLabelDetails = (val, paymentMasterArray) => {
    const labelDetail = paymentMasterArray.find((item) => {
      return val === item.key;
    });
    return labelDetail.label;
  };

  renderEmergencyContact = (hazAdditionalDetails) => {
    const name = hazAdditionalDetails?.emergencyContactName;
    const number = hazAdditionalDetails?.emergencyContactNumber;
    if (name && number) {
      return `${name} | ${number}`;
    }
    if (name) return name;
    if (number) return number;
    return '-';
  };

  renderAdditionalCargoDetails = (cargoType) => {
    if (cargoType === 'REEFER') {
      return this.renderAdditionalReeferDetails();
    } else {
      return this.renderAdditionalHazDetails();
    }
  };

  renderInttraPaymentDetails = (classes, inttraBookingDetails) => {
    const { chargeTypes, freightTerms, payer } = this.props.bookingMasterData;
    const { paymentDetails } = inttraBookingDetails;
    return (
      <React.Fragment>
        <Row style={{ padding: '15px 0px' }}>
          <Col span={4}>
            <div className={classes.detailsTitle}>Payment Details</div>
          </Col>
          <Col span={20} style={{ marginBottom: '20px' }}>
            <Row>
              <Col span={6} className={classes.label} style={{ paddingRight: '6px' }}>
                Charge Type
              </Col>
              <Col span={6} className={classes.label} style={{ paddingRight: '6px' }}>
                Freight Terms
              </Col>
              <Col span={6} className={classes.label} style={{ paddingRight: '6px' }}>
                Payer Party
              </Col>
              <Col span={6} className={classes.label} style={{ paddingRight: '6px' }}>
                Name
              </Col>
            </Row>
            {paymentDetails.map((paymentInfo) => {
              return (
                <Row>
                  <Col
                    span={6}
                    className={classes.labelInfo}
                    style={{ marginTop: '10px', paddingRight: '6px' }}
                  >
                    {this.getPaymentLabelDetails(paymentInfo.chargeType, chargeTypes)}
                  </Col>
                  <Col
                    span={6}
                    className={classes.labelInfo}
                    style={{ marginTop: '10px', paddingRight: '6px' }}
                  >
                    {this.getPaymentLabelDetails(paymentInfo.freightTerms, freightTerms)}
                  </Col>
                  <Col
                    span={6}
                    className={classes.labelInfo}
                    style={{ marginTop: '10px', paddingRight: '6px' }}
                  >
                    {this.getPaymentLabelDetails(paymentInfo.payer, payer)}
                  </Col>
                  <Col
                    span={6}
                    className={classes.labelInfo}
                    style={{ marginTop: '10px', paddingRight: '6px' }}
                  >
                    {paymentInfo.name}
                  </Col>
                </Row>
              );
            })}
          </Col>
        </Row>
        {this.renderDivider()}
      </React.Fragment>
    );
  };

  renderInttraAdditionalDetails = (classes, inttraBookingDetails) => {
    const { contractNumber, bookingOffice, agreementReference } = inttraBookingDetails;
    return (
      <React.Fragment>
        <Row style={{ padding: '15px 0px' }}>
          <Col span={4}>
            <div className={classes.detailsTitle}>Additional Details</div>
          </Col>
          <Col span={20}>
            <Row style={{ paddingTop: '2px', marginBottom: '20px' }}>
              <Col span={4} className={classes.label}>
                Contract Number
              </Col>
              <Col span={8} className={classes.labelInfo} style={{ paddingLeft: '15px' }}>
                {contractNumber || '-'}
              </Col>
              <Col span={4} className={classNames(classes.label)} style={{ paddingLeft: '10px' }}>
                Booking Office
              </Col>
              <Col span={8} className={classes.labelInfo} style={{ paddingLeft: '7px' }}>
                {!isEmpty(bookingOffice) ? `${bookingOffice.name} (${bookingOffice.code})` : '-'}
              </Col>
              {agreementReference && <>
                <Col span={4} className={classes.label} style={{ marginTop: '15px' }}>
                  Agreement Reference
                </Col>
                <Col span={8} className={classes.labelInfo} style={{ paddingLeft: '15px', marginTop: '15px' }}>
                  {agreementReference}
                </Col>
              </>}
            </Row>
          </Col>
        </Row>
        {this.renderDivider()}
      </React.Fragment>
    );
  };

  renderInttraNotifyUsers = (classes, inttraBookingDetails) => {
    const { notifyUsers } = inttraBookingDetails;
    return (
      <React.Fragment>
        <Row style={{ padding: '15px 0px' }}>
          <Col span={4}>
            <div className={classes.detailsTitle}>Notify Users</div>
          </Col>
          <Col
            span={20}
            className={classes.label}
            style={{ paddingTop: '2px', marginBottom: '20px' }}
          >
            {notifyUsers.map((user, index) => {
              return (
                <div key={index} style={{ marginBottom: '10px', fontSize: `${tokens.fontSize.body}px` }}>
                  {' '}
                  {user.name}
                  {' | '}
                  {user.email}{' '}
                </div>
              );
            })}
          </Col>
        </Row>
        {this.renderDivider()}
      </React.Fragment>
    );
  };

  renderInttraRemarks = (classes, inttraBookingDetails) => {
    const { remarks } = inttraBookingDetails;
    return (
      <React.Fragment>
        <Row style={{ padding: '15px 0px' }}>
          <Col span={4}>
            <div className={classes.detailsTitle}>Remarks</div>
          </Col>
          <Col
            span={20}
            className={classes.labelInfo}
            style={{ paddingTop: '2px', marginBottom: '20px' }}
          >
            {remarks}
          </Col>
        </Row>
        {this.renderDivider()}
      </React.Fragment>
    );
  };

  renderInttraRecipientMail = (classes, inttraBookingDetails) => {
    const { bookingNoteToBeDeliveredEmail } = inttraBookingDetails;
    return (
      <React.Fragment>
        <Row style={{ padding: '15px 0px' }}>
          <Col span={4}>
            <div className={classes.detailsTitle} style={{ marginBottom: '20px' }}>
              Booking Note Recipient mail
            </div>
          </Col>
          <Col span={20} className={classes.label} style={{ paddingTop: '2px', fontSize: `${tokens.fontSize.body}px` }}>
            {bookingNoteToBeDeliveredEmail}
          </Col>
        </Row>
        {this.renderDivider()}
      </React.Fragment>
    );
  };

  handleTabChange = (activeTab) => {
    this.setState({ activeTab });
  };

  renderTabPanes = (classes) => {
    return (
      <span className={classes.tabContainer}>
        <Tabs activeKey={this.state.activeTab} onChange={this.handleTabChange} size="large">
          <Tabs.TabPane tab={'Shipper Request Details'} key={'1'} />
          <Tabs.TabPane tab={'INTTRA Details'} key={'2'} />
        </Tabs>
      </span>
    );
  };

  renderShipperRequestDetails = (classes, inquiryFFDetails) => {
    return (
      <React.Fragment>
        {this.renderInquiryLocationDetails(classes, inquiryFFDetails)}
        {this.renderDivider()}
        {this.renderInquiryServices(classes, inquiryFFDetails)}
        {this.renderDivider()}
        {this.renderInquiryTermsNConditions(classes, inquiryFFDetails)}
        {this.renderDivider()}
        {this.renderReferenceRate(inquiryFFDetails)}
        {this.renderDivider()}
        {this.renderDocuments(classes, inquiryFFDetails)}
      </React.Fragment>
    );
  };

  renderPartiesColumn = () => {
    const { classes } = this.props;
    return <div className={classes.flexRow} style={{ marginBottom: '10px' }}>
      <div style={{ fontWeight: tokens.fontWeight.semibold, width: '15%' }}>Type</div>
      <div style={{ fontWeight: tokens.fontWeight.semibold, width: '25%' }}>Name</div>
      <div style={{ fontWeight: tokens.fontWeight.semibold, width: '40%' }}>Address</div>
    </div>;
  };

  renderPartiesInvolved = (partiesInvolved) => {
    const { classes } = this.props;
    if (!partiesInvolved?.length) {
      return;
    }

    return (
      <React.Fragment>
        <Row style={{ padding: '15px 0px' }}>
          <Col span={4}>
            <div className={classes.detailsTitle}>Parties Involved</div>
          </Col>
          <Col
            span={20}
            className={classes.label}
            style={{ paddingTop: '2px', marginBottom: '20px' }}
          >
            {this.renderPartiesColumn()}
            {partiesInvolved.map((item, index) => {
              return (
                <div
                  className={classes.flexRow}
                  style={{
                    marginBottom: '10px', fontSize: `${tokens.fontSize.body}px`
                  }}
                >
                <div style={{ width: '15%' }} className={classes.title}>{startCase(item.type) || '-'}</div>
                <div style={{ width: '25%' }} className={classes.value}>{item.name || '-'}</div>
                <div style={{ width: '40%' }} className={classes.value}>{getSIPartyAddress(item)}</div>
              </div>
              );
            })}
          </Col>
        </Row>
        {this.renderDivider()}
      </React.Fragment>
    )
  };

  renderIntraaRequestDetails = (
    classes,
    inttraBookingDetails,
    inquiryFFDetails,
    receiveInttraBookingNoteFF
  ) => {
    return (
      <React.Fragment>
        {(inttraBookingDetails.contractNumber || inttraBookingDetails.bookingOffice || inttraBookingDetails.agreementReference) &&
          this.renderInttraAdditionalDetails(classes, inttraBookingDetails)}
        {isValidArray(inttraBookingDetails.paymentDetails) &&
          this.renderInttraPaymentDetails(classes, inttraBookingDetails)}
        {isValidArray(inttraBookingDetails.notifyUsers) &&
          this.renderInttraNotifyUsers(classes, inttraBookingDetails)}
        {isValidArray(inttraBookingDetails?.partiesInvolved) &&
          this.renderPartiesInvolved(inttraBookingDetails?.partiesInvolved)}
        {receiveInttraBookingNoteFF &&
          inttraBookingDetails.bookingNoteToBeDeliveredEmail &&
          this.renderInttraRecipientMail(classes, inttraBookingDetails)}
        {inttraBookingDetails.remarks && this.renderInttraRemarks(classes, inttraBookingDetails)}
      </React.Fragment>
    );
  };

  getSLResponseStatusData = (inttraStatus) => {
    const { classes } = this.props;
    const inttraStatusMap = {
      [SL_RESPONDED_INTTRA_STATUS.PARTIAL]: {
        key: 'Replaced',
        backgroundColor: '#6BBA89',
      },
      [SL_RESPONDED_INTTRA_STATUS.CONFIRMED]: {
        key: 'Confirmed',
        backgroundColor: '#6BBA89',
      },
      [SL_RESPONDED_INTTRA_STATUS.REJECTED]: {
        key: 'Rejected by SL',
        backgroundColor: '#F5222D',
      },
      [SL_RESPONDED_INTTRA_STATUS.PENDING]: {
        key: 'Pending',
        backgroundColor: '#ED8732',
      },
      [SL_RESPONDED_INTTRA_STATUS.CANCELLED]: {
        key: 'Cancelled',
        backgroundColor: '#999999',
      },
    };
    return (
      inttraStatusMap[inttraStatus] && (
        <span className={classes.flexRow} style={{ fontSize: `${tokens.fontSize.body}px` }}>
          <div
            className={classes.statusDot}
            style={{ backgroundColor: inttraStatusMap[inttraStatus].backgroundColor }}
          />
          {inttraStatusMap[inttraStatus].key}
        </span>
      )
    );
  };

  renderTabHeaderDetails = () => {
    const { classes, isBookingSideDrawer } = this.props;
    const { inquiryData: inquiryFFDetails, inttraBookingDetails, activeTab } = this.state;
    let inquiryType = inquiryFFDetails?.type || '';
    // For RPTL mode, don't show the type (which is DOMESTIC)
    const shouldShowType = inquiryFFDetails.mode !== 'RPTL';
    return (
      <div
        style={{ paddingBottom: '30px' }}
        className={isBookingSideDrawer ? classes.bookingType : undefined}
      >
        <div style={{ fontWeight: 600 }}>
          {[
            inquiryFFDetails.mode === 'AIRCARGO'
              ? prettifyString(inquiryFFDetails.mode)
              : inquiryFFDetails.mode,
            shouldShowType ? prettifyString(inquiryType) : null,
            inquiryFFDetails.inquiryNumber,
          ]
            .filter((el) => el)
            .join('|')}
        </div>
      </div>
    );
  };

  showInttraBookingDetails = () => {
    const { showInttraBookingForFF } = this.props;
    const { inttraBookingDetails } = this.state;
    return showInttraBookingForFF && inttraBookingDetails;
  };

  renderInttraErrors = () => {
    const { inttraErrorReasons } = this.state;
    const { classes } = this.props;
    return (
      <div className={classes.inttraError}>
        {getConditionalBullets(inttraErrorReasons)}
        <div style={{ marginTop: '6px' }}>
          <a style={{ color: tokens.colors.primary }} onClick={this.handleRetryInttraRequest}>
            Click here{' '}
          </a>
          to retry INTTRA request
        </div>
      </div>
    );
  };

  handleRetryInttraRequest = () => {
    this.setState({ bookingDetailModalVisible: true });
  };

  closeBookingDetail = (showProtip = false) => {
    this.setState({
      bookingDetailModalVisible: false,
      confirmBookingProtipVisible: showProtip,
    });
  };

  renderResponseDetails = (): React.ReactElement => {
    const { classes, bookingData } = this.props;
    const {
      inttraBookingDetails: { inttraStatus, inttraReferenceNumber },
      slBookingNumber,
      carrierComments,
      reasonForSplitting,
      splitBookingDetails,
    } = this.state;
    const statusLabel = this.getSLResponseStatusData(inttraStatus);
    return (
      <div className={classes.splitBookingDetails}>
        <div className={classNames(classes.splitBookingHeading, classes.justifySpaceBetween)}>
          Response Details {statusLabel}
        </div>
        {
          <Row style={{ padding: '13px 0px' }} className={classes.flexRow}>
            <Col span={4} className={classes.responseLabel}>
              INTTRA Reference #
            </Col>
            <Col span={20} className={classes.inttraStatusDetails}>
              <span className={classes.inttraReferenceDetails}>{inttraReferenceNumber || '-'}</span>
            </Col>
          </Row>
        }
        {slBookingNumber && (
          <Row style={{ padding: '13px 0px' }}>
            <Col span={4} className={classes.responseLabel}>
              Carrier Booking #
            </Col>
            <Col span={20} className={classes.inttraStatusDetails}>
              {slBookingNumber}
            </Col>
          </Row>
        )}
        {(carrierComments || reasonForSplitting) && (
          <Row style={{ padding: '13px 0px' }}>
            <Col span={4} className={classes.responseLabel}>
              Remarks
            </Col>
            <Col span={20} className={classes.inttraStatusDetails}>
              {reasonForSplitting && (
                <div style={{ marginBottom: '8px' }}>{reasonForSplitting}</div>
              )}
              {getConditionalBullets(carrierComments)}
            </Col>
          </Row>
        )}
        {bookingData.inttraStatus === SL_RESPONDED_INTTRA_STATUS.PARTIAL &&
          isValidArray(splitBookingDetails) &&
          this.renderSplitBookingDetails()}
      </div>
    );
  };

  renderSplitBookingDetails = (): React.ReactElement => {
    const { classes } = this.props;
    const { splitBookingDetails } = this.state;
    return (
      <React.Fragment>
        <div className={classes.splitBookingHeading}>Split Booking Details</div>
        <SplitBookingDetails splitBookingData={splitBookingDetails} isSideDrawer={true} />
      </React.Fragment>
    );
  };

  render() {
    const {
      classes,
      booking,
      isBookingSideDrawer,
      receiveInttraBookingNoteFF,
      cardData,
      bookingData,
      handleCloseSideDrawer,
    } = this.props;
    const {
      inquiryData: data,
      isLoading,
      isSelectTeamModalVisible,
      teams,
      teamId,
      inttraBookingDetails,
      activeTab,
      inttraErrorReasons,
      bookingDetailModalVisible,
      splitBookingDetails,
    } = this.state;
    if (isLoading)
      return (
        <div style={{ height: '400px' }}>
          {' '}
          <Loader />
        </div>
      );
    const inquiryFFDetails = data;
    let inquiryType = inquiryFFDetails && inquiryFFDetails.type ? inquiryFFDetails.type : '';
    inquiryType = inquiryType.charAt(0).toUpperCase() + inquiryType.slice(1).toLowerCase();
    const cargoToShow = ['REEFER', 'HAZ'];
    return (
      <div key={data.id}>
        {!this.props.booking && this.header()}
        {this.showInttraBookingDetails() && isBookingSideDrawer && this.renderTabPanes(classes)}
        {data.isRejected && this.renderRejectedInquiryHeader()}
        <div className={this.props.className}>
          {data.mode === InquiryModes.TRAILER || data.mode === InquiryModes.DOMESTIC || data.mode ===  InquiryModes.RPTL ? (
            <TruckingInquiryDetails
              parentClasses={classes}
              isBookingSideDrawer={isBookingSideDrawer}
              inquiryData={data}
              bookingData={bookingData}
            />
          ) : (
            <Card
              className={
                isBookingSideDrawer ? classes.bookingSideDrawer : classes.bookindDetailsDiv
              }
            >
              {this.renderTabHeaderDetails()}
              <div className={classes.body}>
                {activeTab === '2' &&
                  bookingData.ffStatus === BOOKING_STATUS.SL_ERRORED &&
                  inttraErrorReasons &&
                  this.renderInttraErrors()}
                {activeTab === '2' &&
                  bookingData.ffStatus === BOOKING_STATUS.SL_RESPONDED &&
                  (isValidArray(splitBookingDetails) ||
                    inttraBookingDetails?.inttraReferenceNumber ||
                    this.getSLResponseStatusData(inttraBookingDetails?.inttraStatus)) &&
                  this.renderResponseDetails()}
                {activeTab === '1' && this.props.inquiryFormPrefill && (inquiryFFDetails.stakeholder || inquiryFFDetails.customer) && (
                  <React.Fragment>
                    {this.renderStakeholderDetails(classes, inquiryFFDetails)}
                    {this.renderDivider()}
                  </React.Fragment>
                )}
                {activeTab === '1'
                  ? this.renderInquiryBasicDetails(classes, inquiryFFDetails)
                  : this.renderInttraBasicDetails(classes, inttraBookingDetails)}
                {isBookingSideDrawer && cargoToShow?.indexOf(inquiryFFDetails.cargoType) !== -1 && (
                  <React.Fragment>
                    {this.renderDivider()}
                    {this.renderAdditionalCargoDetails(inquiryFFDetails.cargoType)}
                  </React.Fragment>
                )}
                {this.renderDivider()}
                {this.renderPackagingDetails(classes, inquiryFFDetails)}
                {activeTab === '1'
                  ? this.renderInquiryOtherDetails(classes, inquiryFFDetails)
                  : this.renderInttraOtherDetails(classes, inquiryFFDetails, inttraBookingDetails)}
                {this.renderDivider()}
                {activeTab === '1'
                  ? this.renderShipperRequestDetails(classes, inquiryFFDetails)
                  : this.renderIntraaRequestDetails(
                    classes,
                    inttraBookingDetails,
                    inquiryFFDetails,
                    receiveInttraBookingNoteFF
                  )}
              </div>
            </Card>
          )}
        </div>
        {isSelectTeamModalVisible && (
          <TeamForInquiryAccessModal
            isVisible={isSelectTeamModalVisible}
            teams={teams}
            onCancel={() => {
              this.setState({ teamId, isSelectTeamModalVisible: false });
            }}
            handleTeamSelect={this.handleTeamSelect}
            teamId={teamId}
          />
        )}
        {bookingDetailModalVisible && (
          <BookingDetailModal
            cardData={cardData}
            handleCancel={this.closeBookingDetail}
            bookingData={bookingData}
            bookingId={cardData.bookingNumber}
            visible={bookingDetailModalVisible}
            isAmend={true}
            isRetryInttraRequest={true}
            handleCloseSideDrawer={handleCloseSideDrawer}
          />
        )}
      </div>
    );
  }
}

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      getInquiryDetail,
    },
    dispatch
  );
const mapStateToProps = (state) => {
  const {
    staticData: { containerTypesKeyVal: containerTypes },
    masterData: {
      permissions,
      currencySymbols,
      userData,
      timezone,
      modules: {
        show_inttra_booking_ff: showInttraBookingForFF,
        receive_inttra_booking_note_email: receiveInttraBookingNoteFF,
        enable_default_inquiry_team_mapping: isDefaultInquiryTeamMapping,
        inquiry_form_prefill: inquiryFormPrefill,
        enable_dispatch_mode: enableDispatchMode
      },
      bookingMasterData,
      visibleAccessTypes,
      customFieldsForInquiry,
      inquiryDefaults
    },
    inquiryReducer: {
      masterData: { lclPackageTypes, airCargoPackageTypes, referenceRateBasis, haulage, allowedDocumentTypes },
    },
    inquiryShipperReducer: { appliedFilters },
  } = state;
  return {
    permissions,
    containerTypes,
    lclPackageTypes,
    airCargoPackageTypes,
    currencySymbols,
    referenceRateBasis,
    haulage,
    showInttraBookingForFF,
    receiveInttraBookingNoteFF,
    isDefaultInquiryTeamMapping,
    inquiryFormPrefill,
    enableDispatchMode,
    bookingMasterData,
    modeList: appliedFilters?.modeList,
    userRole: userData.role,
    userStatus: userData.status,
    visibleAccessTypes: visibleAccessTypes?.INQUIRY ?? [],
    allowedDocumentTypes,
    customFieldsForInquiry,
    organisationId: userData?.organisation_id,
    inquiryDefaultFormConfig: inquiryDefaults?.defaultFormFieldConfig,
    timezone,
  };
};
const CreateInquiryDetailsStyled = injectSheet(styles)(CreateInquiryDetails);
export default withRouter(
  withInquiryMasterData(connect(mapStateToProps, mapDispatchToProps)(CreateInquiryDetailsStyled))
);
